// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/components/Common/Fonts/Montserrat/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/components/Common/Fonts/Montserrat/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/components/Common/Fonts/Fjalla_One/FjallaOne-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../src/components/Common/Fonts/Source_Sans_Pro/SourceSansPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../src/components/Common/Fonts/Source_Serif_Pro/SourceSerifPro-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:application/font-woff;charset=utf-8;base64, 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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --illiniOrange: #ff552e;
  --illiniDarkBlue: #13294b;
  --backgroundGrey: #e5e5e5;
  --darkGrey: #f2f2f2;
  --cloudGrey: #f8f8f8;
  --lightGrey: #d6d6d6;
  --middleGrey: #e4e4e4;
  --darkestGrey: #6d6d6d;
  --white: #fff;
}

@font-face {
  font-family: Monsterrat;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("truetype");
}

@font-face {
  font-family: Monsterrat Bold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("truetype");
}

@font-face {
  font-family: Fjalla_One;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format("truetype");
}

@font-face {
  font-family: Source Sans Pro;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
    format("truetype");
}

@font-face {
  font-family: Source Serif Pro;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___})
    format("truetype");
}

html {
  font-family: "Source Sans Pro";
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
main {
  flex: 1 1;
  background: var(--white);
  width: 100%;
  margin: 0 auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 0rem 1rem 0rem 1rem;
}

.form-control {
  width: 250px;
  position: relative;
  height: 2.5rem;
  appearance: none;
  text-indent: 1px;
  box-sizing: border-box;
  flex: 1 0;
  background: transparent;
  padding-left: 0.5rem;
  border-radius: 4px;
  border: 1px solid grey;
}

.mainWrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.whiteText {
  color: #fff;
}

h2,
article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
progress,
video {
  display: inline-block;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
progress {
  vertical-align: baseline;
}
[hidden],
template {
  display: none;
}
a {
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:active,
a:hover {
  outline-width: 0;
}
abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}
b,
strong {
  font-weight: inherit;
  font-weight: bolder;
}
dfn {
  font-style: italic;
}
h1 {
  font-family: "Monsterrat";
  font-weight: 700;
  font-size: 2em;
  margin: 0.67em 0;
}
mark {
  background-color: #ff0;
  color: #000;
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
img {
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}
figure {
  margin: 1em 40px;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
button,
input,
optgroup,
select,
textarea {
  font: inherit;
  margin: 0;
}
optgroup {
  font-weight: 700;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
[type="reset"],
[type="submit"],
button,
html [type="button"] {
  -webkit-appearance: button;
}
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner,
button::-moz-focus-inner {
  border-style: none;
  padding: 0;
}
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring,
button:-moz-focusring {
  outline: 1px dotted ButtonText;
}
fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  box-sizing: border-box;
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}
textarea {
  overflow: auto;
}
[type="checkbox"],
[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-input-placeholder {
  color: inherit;
  opacity: 0.54;
}
::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}
html {
  font: 112.5%/1.45em arial, georgia, serif;
  box-sizing: border-box;
  overflow-y: scroll;
}
* {
  box-sizing: inherit;
}
*:before {
  box-sizing: inherit;
}
*:after {
  box-sizing: inherit;
}
body {
  color: hsla(0, 0%, 0%, 0.8);
  font-family: "arial", georgia, serif;
  font-weight: normal;
  word-wrap: break-word;
  font-kerning: normal;
  -ms-font-feature-settings: "kern", "liga", "clig", "calt";
  font-feature-settings: "kern", "liga", "clig", "calt";
}
img {
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}

a {
  text-decoration: none;
  color: #000;
}

p {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1.1rem;
  line-height: 1.7rem;
}

h1 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 2.2rem;
  line-height: 40px;
  color: var(--illiniDarkBlue);

  width: 100%;
}

h2 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 40px;
  color: var(--illiniDarkBlue);

  width: 100%;
}
h3 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 40px;
  color: var(--illiniDarkBlue);
  margin-top: 0;

  width: 100%;
}
h4 {
  font-family: Arial;
  font-weight: 800;
  font-size: 1.2rem;
  letter-spacing: 1px;
}
h5 {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-variant: normal;
  font-weight: 200;
  letter-spacing: 1px;
  margin-bottom: 10px;
  color: #000;
  text-transform: uppercase;
}
h6 {
  font-family: "Times New Roman";
  font-size: 28px;
  color: #fff;
  font-style: italic;
  margin: 40px 20% 20px 20%;
  line-height: 35px;
}
hgroup {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
ul {
  margin-left: 1.45rem;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  list-style-position: outside;
  list-style-image: none;

  width: 100%;
}

ol {
  margin-left: 1.45rem;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  list-style-position: outside;
  list-style-image: none;
}
dl {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
dd {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
p {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
figure {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
pre {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 1.45rem;
  font-size: 0.85rem;
  line-height: 1.42;
  background: hsla(0, 0%, 0%, 0.04);
  border-radius: 3px;
  overflow: auto;
  word-wrap: normal;
  padding: 1.45rem;
}
table {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
  font-size: 1rem;
  line-height: 1.45rem;
  border-collapse: collapse;
  width: 100%;
}
fieldset {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
blockquote {
  margin-left: 1.45rem;
  margin-right: 1.45rem;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
form {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
noscript {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
iframe {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
hr {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: calc(1.45rem - 1px);
  background: hsla(0, 0%, 0%, 0.2);
  border: none;
  height: 1px;
}
address {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  margin-bottom: 1.45rem;
}
b {
  font-weight: bold;
}
strong {
  font-weight: bold;
}
dt {
  font-weight: bold;
}
th {
  font-weight: bold;
}
li {
  margin-bottom: 0;
}
ol li {
  padding-left: 0;
}
ul li {
  padding-left: 0;
}
li > ol {
  margin-left: 1.45rem;
  margin-top: calc(1.45rem / 2);
}
li > ul {
  margin-left: 1.45rem;
  margin-top: calc(1.45rem / 2);
}
blockquote *:last-child {
  margin-bottom: 0;
}
li *:last-child {
  margin-bottom: 0;
}
p *:last-child {
  margin-bottom: 0;
}
li > p {
  margin-bottom: calc(1.45rem / 2);
}
code {
  font-size: 0.85rem;
  line-height: 1.45rem;
}
kbd {
  font-size: 0.85rem;
  line-height: 1.45rem;
}
samp {
  font-size: 0.85rem;
  line-height: 1.45rem;
}
abbr {
  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
  cursor: help;
}
acronym {
  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
  cursor: help;
}
abbr[title] {
  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);
  cursor: help;
  text-decoration: none;
}
thead {
  text-align: left;
}
td,
th {
  text-align: left;
  border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);
  font-feature-settings: "tnum";
  -moz-font-feature-settings: "tnum";
  -ms-font-feature-settings: "tnum";
  -webkit-font-feature-settings: "tnum";
  padding-left: 0.96667rem;
  padding-right: 0.96667rem;
  padding-top: 0.725rem;
  padding-bottom: calc(0.725rem - 1px);
}

tt,
code {
  background-color: hsla(0, 0%, 0%, 0.04);
  border-radius: 3px;
  font-family: "SFMono-Regular", Consolas, "Roboto Mono", "Droid Sans Mono",
    "Liberation Mono", Menlo, Courier, monospace;
  padding: 0;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
}
pre code {
  background: none;
  line-height: 1.42;
}
code:before,
code:after,
tt:before,
tt:after {
  letter-spacing: -0.2em;
  content: " ";
}
pre code:before,
pre code:after,
pre tt:before,
pre tt:after {
  content: "";
}

.submitButton {
}

.submitButton:hover {
  color: var(--white) !important;
  background: var(--illiniDarkBlue) !important;
}
.primaryTitle {
  font-family: "Monsterrat";
  font-weight: 800;
  font-size: 3rem;
  line-height: 3rem;
  color: var(--illiniDarkBlue);
}
.secondaryTitle {
  font-family: "Monsterrat";
  font-weight: 800;
  font-size: 2.5rem;
  color: var(--illiniDarkBlue);
  line-height: 2.5rem;
}
.tertiaryTitle {
  font-family: "Source Sans Pro";
  font-weight: 600;
  font-size: 2rem;
  color: var(--illiniDarkBlue);
}
.headline {
  font-family: "Source Sans Pro";
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--illiniDarkBlue);
  font-style: normal;
}
.paragraphLarge {
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  color: var(--darkestGrey);
}
.paragraphSmall {
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  color: var(--darkestGrey);
}

.paragraph {
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  color: var(--darkestGrey);
}
.paragraphSmallBlue {
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  color: var(--illiniDarkBlue);
}
.primaryLabel {
  font-family: "Monsterrat";
  font-weight: 800;
  font-size: 1rem;
  font-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--illiniDarkBlue);
}
.secondaryLabel {
  font-family: "Monsterrat";
  font-weight: 800;
  font-size: 1rem;
  font-spacing: 1.5px;
  text-transform: uppercase;
  color: var(--illiniOrange);
}
.detail {
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  color: var(--darkestGrey);
}
.primaryLinkLarge {
  font-family: "Source Sans Pro";
  font-weight: 700;
  font-size: 1.25rem;
  color: var(--illiniDarkBlue);
}
.primaryLink {
  font-family: "Source Sans Pro";
  font-weight: 700;
  font-size: 1rem;
}
.secondaryLink {
  font-family: "Source Sans Pro";
  font-weight: 600;
  font-size: 1rem;
  color: var(--illiniDarkBlue);
}
.unitTitleLarge {
  font-family: "Source Sans Pro";
  font-weight: 700;
  font-size: 1.5rem;
  color: var(--illiniDarkBlue);
}
.unitTitleSmall {
  font-family: "Source Sans Pro";
  font-weight: 700;
  font-size: 1rem;
  color: var(--illiniDarkBlue);
}

.underline {
  text-decoration: underline;
}

.wp-block-video {
  max-width: 100%;
}

video {
  max-width: 100%;
}

.wp-block-code {
  display: none;
}

iframe {
  width: 100%;
}

.rightTop {
  margin-top: 6rem;
}

.pageImage {
  margin-bottom: 1rem;
}

.rowWrapper {
  width: 100%;
  display: flex;
  flex: 1 1;
}

/* THE FOLLOWING LINES COULD GO INTO STYLED.JS FILES LATER */
.wizard li {
  color: #000;
  display: inline-block;
  position: relative;
  background: #ccc;
  padding: 15px 0;
  width: 300px;
  text-align: center;
  margin: 2px;
}

.wizard li:after {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 100%;
  width: 0;
  height: 0;
}

.wizard li.inprogress {
  color: #fff;
  background: #337ab7;
  height: 120px;
  padding: 20px;
  text: "Inpogress";
}

.wizard li.inprogress:after {
  border-top: 20px solid #337ab7;
  border-right: 150px solid transparent;
  border-bottom: 0 solid transparent;
  border-left: 150px solid transparent;
}

.wizard li.complete {
  color: #fff;
  background: #8d8d8d;
}

.wizard li.complete:after {
  border-top: 0px;
}

.circle {
  margin: 10px;
  border-radius: 50%;
  width: 75px;
  height: 75px;
  padding: 4px;
  border: 2px solid #ccc;
  color: #fff;
  text-align: center;

  /*  width: 100px; height: 100px; background: red; border-radius: 50% */
}

.circle-active {
  background-color: #28a745;
  cursor: pointer;
  animation: pulse 2s infinite;
}

.circle {
  border-radius: 50%;
  width: 35px;
  height: 35px;
  padding: 4px;
  color: #fff;
  margin: 5px;
}

.circle.active {
  background: #0d6efd;
}

.circle.inactive {
  background: #6c757d;
}

.circle.complete {
  background: #000;
}

.circles-active {
  background-color: #28a745;
  cursor: pointer;
  animation: pulse 2s infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

/* Popup container */
.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

/* The actual popup (appears on top) */
.popup .popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  opacity: 0.5;
  /*background-color: rgba(255, 255, 255, .15);  */
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
  backdrop-filter: blur(5px);
}

/* Popup arrow */
.popup .popuptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

/* Toggle this class when clicking on the popup container (hide and show the popup) */
.popup .show {
  visibility: visible;
  animation: fadeIn 1s;
}

/* Add animation (fade in the popup) */

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* FINISH COMMENT STYLED JS --------------*/

.slice {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 50%;
  transform-origin: 0% 100%;
}

.breadcrumbBar {
  color: var(--illiniDarkBlue);
  width: 1180px;
  display: flex;
  padding-top: 1rem;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  height: 3rem;
}
.wp-block-separator {
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.rowTeams {
  width: 100%;
  min-height: 500px;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-round;
}
.col-sm-4 {
  width: 33.333%;
  float: left;
  position: relative;
  min-height: 1px;
}
.service-item {
  display: -webkit-flex;
  flex-flow: column;
  height: 430px;
  width: 95%;
  margin: 0 auto;
  border: 1px solid #f1f1f1;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  background: white;
}

.title-wrapper {
  padding: 3rem 2rem;
  text-align: center;
  text-align: center;
}

.title-wrapper .entry-title {
  margin: 0 0 0.5rem;
  font-size: 1.5rem;
  position: relative;
  padding-bottom: 0.5rem;
}

.title-wrapper .entry-content {
  margin: 0.5rem 0 0;
}

.teamsInfoHide {
  display: none;
}

.teamsInfoShow {
  display: block;
  background: white;
  width: 100%;
  margin: 0 auto;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  padding-top: 20px;
  padding-bottom: 20px;
  margin-top: 30px;
}

.hoverLink {
  text-decoration: none !important;
  color: inherit;
  transition: border-color 0.2s ease 0s;
  color: var(--illiniDarkBlue);
}

.hoverLink:hover {
  text-decoration: underline !important;
}
.teamsInfoInner {
  width: 90%;
  margin: 0 auto;
}

.optanon-alert-box-wrapper {
  background-color: rgba(0, 0, 0, 0.8) !important;
}
.optanon-alert-box-wrapper
  .optanon-button-more
  .optanon-alert-box-button-middle
  a:before {
  content: none;
}
.optanon-alert-box-wrapper
  .optanon-button-allow
  .optanon-alert-box-button-middle
  a:before {
  content: none;
}
.optanon-alert-box-wrapper .optanon-alert-box-button-middle {
  background-color: #57802d !important;
}
.optanon-alert-box-body a {
  color: #fff !important;
  text-decoration: underline !important;
  padding-left: 5px;
}
@media only screen and (max-width: 752px) {
  .optanon-alert-box-wrapper .optanon-alert-box-bg p {
    font-size: 9pt;
    line-height: 12pt;
  }
  .optanon-alert-box-bg .optanon-alert-box-button-container {
    text-align: right;
    margin-left: 1em;
  }
}

.whitebg {
  background-color: var(--white);
}
.container h3 {
  width: 100%;
}

.container h4 {
  width: 100%;
}
.wp-block-ub-tabbed-content {
  max-width: 100%;
  overflow-x: scroll;
}

.imgMargin {
  margin-bottom: 0px;
  padding-right: 0.5rem;
}

.whiteTxt {
  color: var(--white);
}

.darkBlueTxt {
  color: var(--illiniDarkBlue);
}

.greyDarkestTxt {
  color: var(--darkestGrey);
}

.module_header {
  padding-right: 1rem;
}

.serviceTop {
  max-width: 800px;
}

.container ul {
  list-style: none;
  color: var(--darkestGrey);
  font-family: "Source Sans Pro";
  font-weight: 400;
  font-size: 1rem;
  text-align: left;
}

.container li {
  margin-bottom: 0;
}

.iconContainer {
  border-radius: 0.25rem;
}

.container li::before {
  content: "•";
  color: var(--illiniOrange);
  padding-right: 1rem;
}

.serviceTop h2 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  color: var(--illiniDarkBlue);
}

.providerImage {
  margin-bottom: 2rem;
  width: 500px;
  height: auto;
  float: left;
}

.container {
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1180px;
  margin: 0 auto;
}

.newsImage {
  max-width: 100%;
  height: auto;
}

.wp-block-ub-tabbed-content-tab-title-vertical-wrap .active {
  background-color: var(--illiniDarkBlue);
  color: var(--white);
}

.newsTop {
  width: 100%;
}

.cardTop {
  padding: 1.5rem;
  width: 100%;
  padding-bottom: 0;
  display: flex;
}

.leftWrap {
  padding: 1.5rem;
  padding-right: 0;
  max-width: 50%;
  display: flex;
  flex-wrap: wrap;
}

.container a {
  text-decoration: underline;
  font-style: italic;
}

.newsBottom p {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: var(--darkestGrey);
}

.newsBottom h2 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: var(--illiniDarkBlue);
}

.newsBottom h3 {
  font-family: "Source Sans Pro";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  color: var(--illiniDarkBlue);
}

.newsBottom img {
  padding: 1rem;
  height: auto;
  max-width: 100%;
  float: right;
}
ol {
  list-style: none;
  color: var(--darkestGrey);
  width: 100%;
}

.results {
  list-style: none;
}

.categoryIcon {
  width: 2rem;
  margin-right: 1rem;
  height: 2rem;
  margin-bottom: 0px;
  margin-top: 0px;
}

.secondaryLabelMax {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}

.selected {
  background: var(--illiniDarkBlue);
  color: white;
}

.selected:hover {
  color: var(--illiniDarkBlue);
  border: 2px solid var(--illiniDarkBlue);
}

.wp-block-file__button {
  background: var(--illiniDarkBlue);
  color: var(--white);
  border-radius: 0.5rem;
  padding: 0.5rem;
  /* border: 1px solid var(--illiniOrange); */
  margin-left: 1rem;
  margin-right: 1rem;
  line-height: 3rem;

  text-decoration: none !important;
  font-style: normal !important;
}

.wp-block-file > a:first-of-type {
  text-decoration: underline;
  font-style: italic;
}

.wp-block-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.wp-block-gallery > figure {
  width: 30%;
}

@media only screen and (max-width: 992px) {
  .col-sm-4 {
    width: 50%;
    float: left;
    position: relative;
    min-height: 1px;
  }

  .rightTop {
    margin-top: 0rem;
  }
  .leftWrap {
    max-width: 100%;
    width: 100%;
  }

  .pageImage {
    margin-bottom: 1rem;
  }

  .wp-block-gallery > figure {
    width: 45%;
  }

  .container {
    padding: 2rem;
    justify-content: space-around;
  }
  .wp-block-group__inner-container {
    width: 80vw;
    max-width: 80vw;
  }

  .serviceTop {
    text-align: center;
    word-wrap: revert;
    max-width: 100%;
    justify-content: center;
  }

  .wp-block-ub-content-toggle {
    width: 50%;
  }

  .test {
  }
}
@media only screen and (max-width: 480px) {
  .col-sm-4 {
    width: 100%;
    float: left;
    position: relative;
    min-height: 1px;
  }
  .leftWrap {
    max-width: 100%;
    width: 100%;
  }

  .wp-block-gallery > figure {
    width: 100%;
  }

  .primaryTitle {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }
  html {
    font-size: 100%;
  }

  .wp-block-ub-content-toggle {
    width: 100%;
  }
  .wp-block-group__inner-container {
    width: 80vw;
    max-width: 80vw;
  }

  .container {
    width: 100%;
    padding: 1rem;
  }

  .serviceTop {
    text-align: center;
    word-wrap: revert;
    max-width: 100%;
    justify-content: center;
  }

  .contactCardHolder {
    width: 300px;
    margin: 0 auto;
    display: block;
  }
}

.wp-block-ub-content-toggle-accordion {
}

.nope {
  color: rgba(0, 0, 0, 0);
}

.ub-advanced-video-container {
  width: fit-content;
  max-width: 100%;
}

.ub-advanced-video-thumbnail {
  position: relative;
}

.ub-advanced-video-thumbnail > svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ub-advanced-video-embed.ub-advanced-video-autofit-youtube {
  width: 100%;
}

.ub-advanced-video-embed.ub-advanced-video-autofit-youtube > iframe {
  width: 100%;
}

.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo,
.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {
  position: relative;
}

.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo > iframe,
.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion > iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {
  height: 0;
  overflow: hidden;
}

.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion > iframe {
  overflow: hidden;
}

.wp-block-ub-button-block {
  margin: 30px auto;
  max-width: 100%;
}

.ub-button-container {
  max-width: 100%;
  display: flex;
  padding: 10px 0;
  margin: 20px 0;
}

.ub-button-container a.ub-button-block-main.ub-button-block-main,
.ub-button-container a.ub-button-block-btn.ub-button-block-btn {
  text-decoration: none;
}

.ub-button-full-container {
  width: 100%;
}

.ub-button-block-main {
  display: flex;
  cursor: pointer;
  transition: background-color 0.5s, color 0.5s, border 0.5s;
}

.align-button-center {
  justify-content: center;
}

.align-button-left {
  justify-content: flex-start;
}

.align-button-right {
  justify-content: flex-end;
}

.ub-button-small {
  width: 180px;
  padding: 10px;
  font-size: 13px !important;
}

.ub-button-medium {
  width: 275px;
  padding: 15px;
  font-size: 17px !important;
}

.ub-button-large {
  width: 417px;
  padding: 20px;
  font-size: 22px !important;
}

.ub-button-larger {
  width: 512px;
  padding: 20px;
  font-size: 25px !important;
}

.ub-button-flex-small {
  width: fit-content;
  width: -moz-fit-content;
}

.ub-button-flex-medium {
  width: fit-content;
  width: -moz-fit-content;
}

.ub-button-flex-large {
  width: fit-content;
  width: -moz-fit-content;
}

.ub-button-flex-larger {
  width: fit-content;
  width: -moz-fit-content;
}

.ub-button-block-btn {
  text-align: center;
  color: inherit;
  margin: 0 10px;
  display: flex;
  align-items: center;
}

.ub-button-content-holder {
  display: flex;
  margin: 0 auto;
}

.ub-button-icon-holder {
  display: flex;
  align-items: center;
  padding: 0 2px;
}

.ub-button-full-width {
  width: 100%;
}

.ub-buttons {
  margin: 20px 0;
}

.ub-buttons.align-button-center {
  text-align: center;
}

.ub-buttons.align-button-left {
  text-align: left;
}

.ub-buttons.align-button-right {
  text-align: right;
}

.ub-buttons > .ub-button-container {
  display: inline-block;
  margin: 0 10px;
}

@media (max-width: 599px) {
  .ub-button-flex-small {
    min-width: 70%;
  }
  .ub-button-flex-medium {
    min-width: 80%;
  }
  .ub-button-flex-large {
    min-width: 90%;
  }
  .ub-button-flex-larger {
    min-width: 100%;
  }
}

.wp-block-ub-block-call-to-action {
  margin: 0 auto;
  max-width: 100%;
}

.ub_call_to_action {
  box-sizing: border-box;
  width: 100%;
  padding: 0 60px;
  margin: 30px 0 60px 0;
  border-style: solid;
  border-radius: 3px;
}

.ub_call_to_action .ub_call_to_action_button {
  display: flex;
  align-items: center;
}

.ub_call_to_action .ub_call_to_action_button .ub_cta_button a,
.ub_call_to_action .ub_call_to_action_button a.ub_cta_button {
  text-decoration: none;
}

.ub_call_to_action_headline {
  width: 100%;
  padding: 20px 20px 10px 20px;
}

.ub_call_to_action_headline p,
.ub_call_to_action_headline h2 {
  text-align: center;
  margin: 0;
  padding: 20px 20px 0 20px;
}

.ub_call_to_action_content {
  width: 100%;
  padding: 0 0 15px 0;
}

.ub_call_to_action_content p {
  text-align: justify;
}

.ub_cta_button {
  margin-bottom: -31px !important;
  padding: 20px !important;
  position: relative;
  box-sizing: border-box;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 3px;
}

.ub_cta_button_text {
  margin: 0 !important;
  text-align: center;
}

@media (max-width: 1199.98px) {
  .ub_call_to_action {
    padding: 0 30px;
  }
}

@media (max-width: 991.98px) {
  .ub_call_to_action {
    padding: 0 20px;
    margin-bottom: 60px !important;
  }
  .ub_call_to_action_headline {
    padding: 20px 0 0 0;
  }
  .ub_call_to_action_headline p {
    line-height: 1.3;
    padding: 20px 0;
  }
}

@media (max-width: 320px) {
  .ub_call_to_action_button .ub_cta_button_text {
    font-size: 14px !important;
    font-weight: 600;
  }
  .ub_call_to_action {
    padding: 0 10px;
  }
}

.wp-block-ub-block-click-to-tweet {
  margin: 0 auto;
  max-width: 100%;
}

.ub_click_to_tweet {
  width: 95%;
  border: 1px solid;
  border-radius: 4px;
  padding: 10px;
  margin: 25px 0px;
}

.ub_tweet {
  padding: 10px;
  margin-left: 10px;
  font-family: "Segoe UI", Arial, sans-serif;
}

.ub_click_tweet {
  text-align: right;
  padding: 10px;
  margin-right: 10px;
}

.ub_click_tweet > span {
  display: inline-block;
}

.ub_click_tweet i {
  display: inline-block;
  width: 16px;
  height: 14px;
  background-position-x: 0%;
  background-position-y: 0%;
  margin-right: 3px;
  position: relative;
  top: 0;
  background-position: 0 -151px;
  width: 25px;
  height: 20px;
}

@media (max-width: 479.98px) {
  .ub_click_tweet {
    width: 100%;
    float: none;
    padding: 0;
    margin: 10px 0 !important;
  }
  .ub_tweet {
    padding: 0;
    margin-left: 0;
    line-height: 1.5;
  }
}

.ub-hide {
  display: none;
}

.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ub-toggle-transition {
  transition: all 0.5s ease-in-out;
}

.ub-icon-holder {
  position: relative;
  transform: translate(-25%, 25%);
}

.ub-custom-id-input {
  font-size: 0.9em;
}

@media (max-width: 699px) {
  .ub-mobile-hide {
    display: none;
  }
  .ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tablet-hide {
    display: none;
  }
  .ub-tablet-display {
    display: block;
  }
}

.ub-content-filter-tag {
  display: inline-block;
  min-height: 32px;
  min-width: 100px;
  margin: 5px 10px 5px 0;
  padding: 8px;
  border-radius: 3px;
  text-align: center;
}

.ub-content-filter-category-name {
  font-size: 1.625em;
  font-weight: 800;
  margin-bottom: 15px;
}

.ub-content-filter-category {
  margin-bottom: 10px;
  padding: 3px;
}

.ub-content-filter-tag {
  cursor: pointer;
}

.ub-hide {
  display: none;
}

.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ub-toggle-transition {
  transition: all 0.5s ease-in-out;
}

.ub-icon-holder {
  position: relative;
  transform: translate(-25%, 25%);
}

.ub-custom-id-input {
  font-size: 0.9em;
}

@media (max-width: 699px) {
  .ub-mobile-hide {
    display: none;
  }
  .ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tablet-hide {
    display: none;
  }
  .ub-tablet-display {
    display: block;
  }
}

.wp-block-ub-content-toggle {
  margin: 20px 0 20px 0;
  max-width: 100%;
  width: 100%;
}

.wp-block-ub-content-toggle-accordion {
  position: relative;

  margin-bottom: 10px;
}

.wp-block-ub-content-toggle-accordion.no-border {
  border: 0 !important;
}

.wp-block-ub-content-toggle-accordion
  .wp-block-ub-content-toggle-accordion-title {
  padding: 10px 10px 10px 25px;
  margin: 0;
  display: block;
}

.wp-block-ub-content-toggle-accordion-content {
  padding: 25px;
}

.wp-block-ub-content-toggle-accordion-controls-top {
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  justify-content: center;
  display: flex;
  opacity: 0;
  transition: 0.5s opacity ease-in-out;
}

.wp-block-ub-content-toggle-accordion-controls-top > span {
  display: inline-block;
  margin: 0 3px;
}

.wp-block-ub-content-toggle-accordion-controls-bottom {
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  justify-content: center;
  display: flex;
  opacity: 0;
  transition: 0.5s opacity ease-in-out;
}

.wp-block-ub-content-toggle-accordion-controls-bottom > span {
  display: inline-block;
  margin: 0 3px;
}

.wp-block-ub-content-toggle-accordion-title-wrap {
  display: flex;
  align-items: center;
  background: var(--illiniDarkBlue);
  color: var(--white);
  cursor: pointer;
}

.wp-block-ub-content-toggle-accordion-title-wrap > *:first-child {
  flex-grow: 1;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-toggle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-toggle-wrap.left {
  order: -1;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-toggle-wrap.right {
  order: 0;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-toggle-wrap
  .wp-block-ub-content-toggle-accordion-toggle-location {
  position: absolute;
  left: 0;
  right: 0;
  top: 150%;
  opacity: 0;
  transition: 0.5s opacity ease-in-out;
  text-align: center;
  color: #191e23;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-state-indicator {
  display: block;
  margin: 0 10px;
  transition: 0.5s all;
  transform: rotate(0deg);
  color: inherit;
}

.wp-block-ub-content-toggle-accordion-title-wrap
  .wp-block-ub-content-toggle-accordion-state-indicator.open {
  transform: rotate(90deg);
}

.wp-block-ub-content-toggle-accordion-content-wrap {
  box-sizing: border-box;
  padding: 13px 4%;
  overflow: hidden;
}

.wp-block-ub-content-toggle-accordion-content-wrap.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.wp-block-ub-content-toggle-accordion:hover
  .wp-block-ub-content-toggle-accordion-controls-top,
.wp-block-ub-content-toggle-accordion:hover
  .wp-block-ub-content-toggle-accordion-controls-bottom,
.wp-block-ub-content-toggle-accordion:hover
  .wp-block-ub-content-toggle-accordion-toggle-location {
  opacity: 1 !important;
}

@media (max-width: 479.98px) {
  .wp-block-ub-content-toggle-accordion
    .wp-block-ub-content-toggle-accordion-title {
    padding: 10px;
  }
}

@media (max-width: 374.98px) {
  .wp-block-ub-content-toggle-accordion
    .wp-block-ub-content-toggle-accordion-title {
    padding: 10px 0 10px 10px;
  }
  .wp-block-ub-content-toggle-accordion-content-wrap p {
    margin: 15px 0 10px;
  }
}

.wp-block-ub-chevron-down {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  width: 22px;
  height: 22px;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 100px;
}

.wp-block-ub-chevron-down::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  transform: rotate(-45deg);
  left: 4px;
  top: 2px;
}

.wp-block-ub-math-plus,
.wp-block-ub-math-plus::after {
  display: block;
  box-sizing: border-box;
  background: currentColor;
  border-radius: 10px;
}

.wp-block-ub-math-plus {
  margin-top: -2px;
  position: relative;
  transform: scale(var(--ggs, 1));
  width: 16px;
  height: 2px;
}

.wp-block-ub-math-plus.open {
  background-color: rgba(0, 0, 0, 0);
}

.wp-block-ub-math-plus::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 16px;
  top: -7px;
  left: 7px;
}

.wp-block-ub-math-plus + .wp-block-ub-content-toggle-accordion-toggle-location {
  margin-top: 60px;
}

.ub_countdown_circular_container {
  display: grid;
}

.ub_countdown_circular_container p {
  text-align: center;
}

.ub_countdown_circular_container > div {
  margin: 0 auto;
}

.ub_countdown_circular_container > div svg {
  position: absolute;
}

.ub_countdown_circle_path {
  stroke-linecap: round;
  stroke-dashoffset: 0px;
  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,
    stroke 0.3s ease 0s, stroke-width 0.06s ease 0.3s;
  fill-opacity: 0;
}

.ub_countdown_circle_label {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  text-align: center;
}

.ub-countdown-separator {
  margin: 0 auto;
  font-size: 35px;
}

.ub-countdown-odometer-container {
  display: grid;
}

.ub-countdown-odometer-container span {
  text-align: center;
}

.ub-countdown-digit-container {
  height: 1.5em;
  overflow-y: hidden;
  margin: 0 auto;
  font-size: 35px;
}

.ub-countdown-digit-container > .digit,
.ub-countdown-digit-container > .moving-digit {
  float: left;
}

.ub-countdown-odometer {
  margin: 0 auto;
  font-size: 35px;
}

.ub-countdown-odometer-digit,
.ub-countdown-odometer-digits {
  float: left;
}

.ub_countdown_style_selector {
  display: flex;
  flex-direction: row;
}

.ub-countdown {
  margin-bottom: 20px;
}

.ub-countdown > div {
  text-align: initial;
}

@media (max-width: 991.98px) {
  .ub-countdown .ub_countdown_week,
  .ub-countdown .ub_countdown_day,
  .ub-countdown .ub_countdown_hour,
  .ub-countdown .ub_countdown_minute,
  .ub-countdown .ub_countdown_second,
  .ub-countdown-odometer-container span {
    font-size: 14px !important;
  }
}

@media (max-width: 575.98px) {
  .ub-countdown .ub_countdown_week,
  .ub-countdown .ub_countdown_day,
  .ub-countdown .ub_countdown_hour,
  .ub-countdown .ub_countdown_minute,
  .ub-countdown .ub_countdown_second {
    margin: 0 1px;
    font-size: 16px !important;
  }
}

@media (max-width: 479.98px) {
  .ub-countdown-separator,
  .ub-countdown-odometer {
    font-size: 20px;
  }
  .ub-countdown {
    margin-bottom: 20px;
    font-size: 14px;
    display: inline-flex;
  }
  .ub-countdown .ub_countdown_week,
  .ub-countdown .ub_countdown_day,
  .ub-countdown .ub_countdown_hour,
  .ub-countdown .ub_countdown_minute,
  .ub-countdown .ub_countdown_second {
    font-size: 14px !important;
  }
  .ub_countdown_circular_container > div {
    height: 60px;
    width: 60px;
  }
  .ub_countdown_circular_container > div svg {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 374.98px) {
  .ub_countdown_circular_container div {
    height: 50px;
    width: 50px;
  }
  .ub_countdown_circular_container > div svg {
    width: 50px;
    height: 50px;
  }
  .ub-countdown .ub_countdown_week,
  .ub-countdown .ub_countdown_day,
  .ub-countdown .ub_countdown_hour,
  .ub-countdown .ub_countdown_minute,
  .ub-countdown .ub_countdown_second,
  .ub-countdown-odometer-container span,
  .ub-countdown {
    font-size: 10px !important;
  }
}

@media (max-width: 320px) {
  .ub-countdown,
  .ub-countdown-separator,
  .ub-countdown-odometer {
    font-size: 10px;
  }
  .ub_countdown_circular_container > div {
    height: 40px;
    width: 40px;
  }
  .ub_countdown_circular_container > div svg {
    width: 40px;
    height: 40px;
  }
  .ub-countdown .ub_countdown_week,
  .ub-countdown .ub_countdown_day,
  .ub-countdown .ub_countdown_hour,
  .ub-countdown .ub_countdown_minute,
  .ub-countdown .ub_countdown_second {
    margin: 0;
    font-size: 10px !important;
  }
}

.ub_divider {
  display: flex;
  margin-left: auto;
  margin-right: auto;
  align-content: center;
  border-bottom: none;
}

.ub_divider.ub_divider:not(.alignwide):not(.alignfull):not(.alignleft):not(
    .alignright
  ):not(.wp-block-separator):not(.woocommerce) {
  max-width: initial;
}

.entry-content.entry-content .ub_divider {
  background-color: rgba(0, 0, 0, 0);
}

.entry-content.entry-content .ub_divider::before,
.entry-content.entry-content .ub_divider::after {
  content: none;
}

.ub-expand {
  padding-bottom: 1em;
}

.ub-expand-toggle-button {
  display: block;
  cursor: pointer;
}

.ub-hide {
  display: none;
}

.wp-block-ub-feature-box {
  margin: 20px 0 20px 0;
  max-width: 100%;
}

.ub_feature_box {
  display: flex;
  margin: 1rem 0;
}

.ub_feature_box > div {
  text-align: justify;
  margin: 0 auto;
}

.ub_feature_box.column_1 .ub_feature_2,
.ub_feature_box.column_1 .ub_feature_3 {
  display: none;
}

.ub_feature_box.column_1 > div {
  width: 100%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 1rem;
}

.ub_feature_box.column_2 .ub_feature_3 {
  display: none;
}

.ub_feature_box.column_2 > div {
  width: 49%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 1rem;
}

.ub_feature_box.column_3 > div {
  width: 33.2%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 1rem;
}

.ub_feature_box.column_3 > div:first-child {
  margin-left: 0;
}

.ub_feature_box.column_3 > div:last-child {
  margin-right: 0;
}

.ub_feature_box_feature {
  border-radius: 100px;
  overflow: hidden;
  border: medium none;
  max-width: 80px;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: -60px !important;
  margin-bottom: 25px;
}

.ub_feature_one_feature,
.ub_feature_two_feature,
.ub_feature_three_feature {
  font-size: 40px !important;
  text-align: center;
  line-height: 80px !important;
  margin: 0 auto !important;
}

.ub_feature_one_title,
.ub_feature_two_title,
.ub_feature_three_title {
  font-size: 30px !important;
  text-align: center;
  margin: 20px 0 !important;
  padding: 0;
}

.ub_feature_1 > img,
.ub_feature_2 > img,
.ub_feature_3 > img {
  display: flex;
  align-items: center;
  margin-right: auto;
  margin-left: auto;
  max-width: 100%;
}

@media screen and (max-width: 800px) {
  .ub_feature_box.column_3 {
    display: block;
  }
  .ub_feature_box.column_3 > div {
    width: 90% !important;
    margin: 0 !important;
  }
}

@media screen and (max-width: 600px) {
  .ub_feature_box.column_2 {
    display: block;
  }
  .ub_feature_box.column_2 > div {
    width: 90% !important;
    margin: 0 !important;
  }
}

.ub_howto-step-image,
.ub_howto-yield-image {
  width: 100%;
}

.ub_howto-supplies-list img,
.ub_howto-tools-list img {
  max-width: 200px;
}

.ub_howto-section-display {
  margin-left: 1em;
}

.ub_howto figcaption {
  margin-top: 5px;
  text-align: center;
}

.ub_howto-step-display .ub_howto-step {
  list-style-position: outside;
}

.ub_howto-step {
  overflow: auto;
}

.ub_howto-step > figure,
.ub_howto-step > img {
  margin-bottom: 10px;
}

.ub_howto-yield {
  overflow: auto;
}

@media screen and (max-width: 767px) {
  .ub_howto .ub_howto-steps-list .ub_howto-step > figure,
  .ub_howto .ub_howto-section .ub_howto-steps-list .ub_howto-step > figure,
  .ub_howto .ub_howto-step-display .ub_howto-step > figure,
  .ub_howto .ub_howto-section .ub_howto-step-display .ub_howto-step > figure {
    width: 100%;
    float: none;
  }
}

.ub_image_slider {
  margin-bottom: 30px;
}

.ub_image_slider .ub_image_slider_image_caption {
  display: block;
  text-align: center;
}

.ub_image_slider .ub_image_slider_alt {
  font-size: 0.8em;
}

.ub_image_slider .swiper-slide > img,
.ub_image_slider .swiper-slide > picture > img,
.ub_image_slider .swiper-slide figure > img,
.ub_image_slider .swiper-slide figure > picture > img {
  display: block;
  margin: auto;
}

@font-face {
  font-family: "swiper-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___})
    format("woff");
  font-weight: 400;
  font-style: normal;
}

:root {
  --swiper-theme-color: #007aff;
}

.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}

.swiper-container-vertical > .swiper-wrapper {
  flex-direction: column;
}

.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}

.swiper-container-android .swiper-slide,
.swiper-wrapper {
  transform: translate3d(0px, 0, 0);
}

.swiper-container-multirow > .swiper-wrapper {
  flex-wrap: wrap;
}

.swiper-container-multirow-column > .swiper-wrapper {
  flex-wrap: wrap;
  flex-direction: column;
}

.swiper-container-free-mode > .swiper-wrapper {
  transition-timing-function: ease-out;
  margin: 0 auto;
}

.swiper-container-pointer-events {
  touch-action: pan-y;
}

.swiper-container-pointer-events.swiper-container-vertical {
  touch-action: pan-x;
}

.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}

.swiper-slide-invisible-blank {
  visibility: hidden;
}

.swiper-container-autoheight,
.swiper-container-autoheight .swiper-slide {
  height: auto;
}

.swiper-container-autoheight .swiper-wrapper {
  align-items: flex-start;
  transition-property: transform, height;
}

.swiper-container-3d {
  perspective: 1200px;
}

.swiper-container-3d .swiper-wrapper,
.swiper-container-3d .swiper-slide,
.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom,
.swiper-container-3d .swiper-cube-shadow {
  transform-style: preserve-3d;
}

.swiper-container-3d .swiper-slide-shadow-left,
.swiper-container-3d .swiper-slide-shadow-right,
.swiper-container-3d .swiper-slide-shadow-top,
.swiper-container-3d .swiper-slide-shadow-bottom {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.swiper-container-3d .swiper-slide-shadow-left {
  background-image: linear-gradient(
    to left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}

.swiper-container-3d .swiper-slide-shadow-right {
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}

.swiper-container-3d .swiper-slide-shadow-top {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}

.swiper-container-3d .swiper-slide-shadow-bottom {
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}

.swiper-container-css-mode > .swiper-wrapper {
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {
  display: none;
}

.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {
  scroll-snap-align: start start;
}

.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: x mandatory;
}

.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {
  scroll-snap-type: y mandatory;
}

:root {
  --swiper-navigation-size: 44px;
}

.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  width: calc(var(--swiper-navigation-size) / 44 * 27);
  height: var(--swiper-navigation-size);
  margin-top: calc(0px - var(--swiper-navigation-size) / 2);
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--swiper-navigation-color, var(--swiper-theme-color));
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0.35;
  cursor: auto;
  pointer-events: none;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-family: swiper-icons;
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 10px;
  right: auto;
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  content: "prev";
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 10px;
  left: auto;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  content: "next";
}

.swiper-button-prev.swiper-button-white,
.swiper-button-next.swiper-button-white {
  --swiper-navigation-color: #ffffff;
}

.swiper-button-prev.swiper-button-black,
.swiper-button-next.swiper-button-black {
  --swiper-navigation-color: #000000;
}

.swiper-button-lock {
  display: none;
}

.swiper-pagination {
  position: absolute;
  text-align: center;
  transition: 300ms opacity;
  transform: translate3d(0, 0, 0);
  z-index: 10;
}

.swiper-pagination.swiper-pagination-hidden {
  opacity: 0;
}

.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}

.swiper-pagination-bullets-dynamic {
  overflow: hidden;
  font-size: 0;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transform: scale(0.33);
  position: relative;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 50%;
  background: #000;
  opacity: 0.2;
}

button.swiper-pagination-bullet {
  border: none;
  margin: 0;
  padding: 0;
  box-shadow: none;
  appearance: none;
}

.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}

.swiper-pagination-bullet:only-child {
  display: none !important;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
}

.swiper-container-vertical > .swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0px, -50%, 0);
}

.swiper-container-vertical
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 6px 0;
  display: block;
}

.swiper-container-vertical
  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}

.swiper-container-vertical
  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
  .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0 4px;
}

.swiper-container-horizontal
  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.swiper-container-horizontal
  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic
  .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.swiper-container-horizontal.swiper-container-rtl
  > .swiper-pagination-bullets-dynamic
  .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

.swiper-pagination-progressbar {
  background: rgba(0, 0, 0, 0.25);
  position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}

.swiper-container-rtl
  .swiper-pagination-progressbar
  .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}

.swiper-container-horizontal > .swiper-pagination-progressbar,
.swiper-container-vertical
  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 100%;
  height: 4px;
  left: 0;
  top: 0;
}

.swiper-container-vertical > .swiper-pagination-progressbar,
.swiper-container-horizontal
  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  width: 4px;
  height: 100%;
  left: 0;
  top: 0;
}

.swiper-pagination-white {
  --swiper-pagination-color: #ffffff;
}

.swiper-pagination-black {
  --swiper-pagination-color: #000000;
}

.swiper-pagination-lock {
  display: none;
}

.swiper-container-cube {
  overflow: visible;
}

.swiper-container-cube .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
  visibility: hidden;
  transform-origin: 0 0;
  width: 100%;
  height: 100%;
}

.swiper-container-cube .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-cube.swiper-container-rtl .swiper-slide {
  transform-origin: 100% 0;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-cube .swiper-slide-active,
.swiper-container-cube .swiper-slide-next,
.swiper-container-cube .swiper-slide-prev,
.swiper-container-cube .swiper-slide-next + .swiper-slide {
  pointer-events: auto;
  visibility: visible;
}

.swiper-container-cube .swiper-slide-shadow-top,
.swiper-container-cube .swiper-slide-shadow-bottom,
.swiper-container-cube .swiper-slide-shadow-left,
.swiper-container-cube .swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}

.swiper-container-cube .swiper-cube-shadow {
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  z-index: 0;
}

.swiper-container-cube .swiper-cube-shadow:before {
  content: "";
  background: #000;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  filter: blur(50px);
}

.swiper-container-fade.swiper-container-free-mode .swiper-slide {
  transition-timing-function: ease-out;
}

.swiper-container-fade .swiper-slide {
  pointer-events: none;
  transition-property: opacity;
}

.swiper-container-fade .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-fade .swiper-slide-active,
.swiper-container-fade .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-flip {
  overflow: visible;
}

.swiper-container-flip .swiper-slide {
  pointer-events: none;
  backface-visibility: hidden;
  z-index: 1;
}

.swiper-container-flip .swiper-slide .swiper-slide {
  pointer-events: none;
}

.swiper-container-flip .swiper-slide-active,
.swiper-container-flip .swiper-slide-active .swiper-slide-active {
  pointer-events: auto;
}

.swiper-container-flip .swiper-slide-shadow-top,
.swiper-container-flip .swiper-slide-shadow-bottom,
.swiper-container-flip .swiper-slide-shadow-left,
.swiper-container-flip .swiper-slide-shadow-right {
  z-index: 0;
  backface-visibility: hidden;
}

.ub_notify_info,
.ub_notify_success,
.ub_notify_warning {
  margin: 10px 0px;
  padding: 15px;
  border-left-width: 4px;
  border-left-style: solid;
}

.ub_notify_info .ub_notify_text,
.ub_notify_success .ub_notify_text,
.ub_notify_warning .ub_notify_text {
  margin: 0 auto;
}

.ub_notify_info {
  color: #31708f;
  background-color: #d9edf7;
  border-left-color: #31708f;
}

.ub_notify_success {
  color: #3c763d;
  background-color: #dff0d8;
  border-left-color: #3c763d;
}

.ub_notify_warning {
  color: #d8000c;
  background-color: #ffd2d2;
  border-left-color: #d8000c;
}

.wp-block-ub-number-box {
  margin: 50px 0 50px 0;
  max-width: 100%;
}

.ub_number_box {
  display: flex;
  margin: 1rem 0;
  margin-top: 5rem;
}

.ub_number_box > div {
  text-align: justify;
  margin: 0 auto;
}

.ub_number_box.column_1 .ub_number_2,
.ub_number_box.column_1 .ub_number_3 {
  display: none;
}

.ub_number_box.column_1 > div {
  width: 100%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border: 1px solid;
  padding: 1rem;
}

.ub_number_box.column_2 .ub_number_3 {
  display: none;
}

.ub_number_box.column_2 > div {
  width: 49%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border: 1px solid;
  padding: 1rem;
}

.ub_number_box.column_3 > div {
  width: 33.2%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  border: 1px solid;
  padding: 1rem;
}

.ub_number_box.column_3 > div:first-child {
  margin-left: 0;
}

.ub_number_box.column_3 > div:last-child {
  margin-right: 0;
}

.ub_number_box_number {
  border-radius: 100px;
  overflow: hidden;
  border: medium none;
  max-width: 80px;
  margin-left: auto !important;
  margin-right: auto !important;
  margin-top: -60px !important;
  margin-bottom: 25px;
}

.ub_number_one_number,
.ub_number_two_number,
.ub_number_three_number {
  font-size: 40px !important;
  text-align: center;
  line-height: 80px !important;
  margin: 0 auto !important;
}

.ub_number_one_title,
.ub_number_two_title,
.ub_number_three_title {
  font-size: 30px !important;
  text-align: center;
  margin: 10px auto;
  padding: 0;
}

@media screen and (max-width: 800px) {
  .ub_number_box.column_3 {
    display: block;
  }
  .ub_number_box.column_3 > div {
    width: 92% !important;
    margin: 0 !important;
  }
}

@media screen and (max-width: 600px) {
  .ub_number_box.column_2 {
    display: block;
  }
  .ub_number_box.column_2 > div {
    width: 90% !important;
    margin: 0 !important;
  }
}

.ub-hide {
  display: none;
}

.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ub-toggle-transition {
  transition: all 0.5s ease-in-out;
}

.ub-icon-holder {
  position: relative;
  transform: translate(-25%, 25%);
}

.ub-custom-id-input {
  font-size: 0.9em;
}

@media (max-width: 699px) {
  .ub-mobile-hide {
    display: none;
  }
  .ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tablet-hide {
    display: none;
  }
  .ub-tablet-display {
    display: block;
  }
}

.ub-block-post-grid {
  margin: 0 0 1.2em 0;
  position: relative;
}

.ub-block-post-grid .is-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-gap: 0 2em;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-grid {
    display: block;
  }
}

.ub-block-post-grid .is-grid article {
  margin-bottom: 2.5em;
  min-width: 0;
  padding: 0;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-grid article {
    padding-left: 10px;
    padding-right: 10px;
    display: inline-block;
    vertical-align: top;
  }
}

.ub-block-post-grid .is-grid.columns-1 {
  grid-template-columns: 1fr;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-grid.columns-1 article {
    width: 100%;
  }
}

.ub-block-post-grid .is-grid.columns-2 {
  grid-template-columns: 1fr 1fr;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-grid.columns-2 article {
    width: 48%;
  }
}

.ub-block-post-grid .is-grid.columns-3 {
  grid-template-columns: 1fr 1fr 1fr;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-grid.columns-3 article {
    width: 32%;
  }
}

@media only screen and (max-width: 600px) {
  .ub-block-post-grid div[class*="columns"].is-grid {
    grid-template-columns: 1fr;
  }
}

.ub-block-post-grid .ub_block-post-grid-text {
  text-align: left;
}

.ub-block-post-grid a {
  text-decoration: none;
}

.ub-block-post-grid .ub-block-post-grid-image {
  margin-bottom: 1.2em;
}

.ub-block-post-grid .ub-block-post-grid-image img {
  display: block;
  width: 100%;
}

.ub-block-post-grid header .ub-block-post-grid-title {
  margin-top: 0;
  margin-bottom: 15px;
  line-height: 1.2;
}

.ub-block-post-grid header .ub-block-post-grid-title a {
  color: #292929;
  text-decoration: none;
}

.ub-block-post-grid header .ub-block-post-grid-title a:hover {
  text-decoration: underline;
  color: inherit;
}

.ub-block-post-grid .ub-block-post-grid-author,
.ub-block-post-grid .ub-block-post-grid-date {
  display: inline-block;
}

.ub-block-post-grid .ub-block-post-grid-author:not(:last-child):after,
.ub-block-post-grid .ub-block-post-grid-date:not(:last-child):after {
  content: "";
  vertical-align: middle;
  margin: 0 5px;
  line-height: 1;
}

.ub-block-post-grid .ub-block-post-grid-author a {
  color: inherit;
  text-decoration: none;
}

.ub-block-post-grid .ub-block-post-grid-author a:hover {
  color: inherit;
  text-decoration: underline;
}

.ub-block-post-grid .ub-block-post-grid-more-link {
  display: inline-block;
  box-shadow: none;
  transition: 0.3s ease;
  font-weight: bold;
  color: #292929;
  text-decoration: none;
}

.ub-block-post-grid .ub-block-post-grid-more-link:hover {
  text-decoration: underline;
}

.ub-block-post-grid .ub-block-post-grid-excerpt > p:last-child {
  margin-top: 15px;
  margin-bottom: 0;
}

.ub-block-post-grid .is-list article {
  display: grid;
  grid-template-columns: 30% 1fr;
  grid-template-rows: 1fr;
  grid-gap: 0 2em;
  padding: 0;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-list article {
    display: block;
  }
}

.ub-block-post-grid .is-list article:before {
  display: none;
}

.ub-block-post-grid .is-list article:not(:last-child) {
  margin-bottom: 5%;
  padding-bottom: 5%;
}

.ub-block-post-grid .is-list article:not(.has-post-thumbnail) {
  grid-template-columns: 1fr;
}

@media only screen and (min-width: 600px) {
  .ub-block-post-grid .is-list article:not(:last-child) {
    border-bottom: solid 1px #eee;
  }
}

@media only screen and (max-width: 600px) {
  .ub-block-post-grid .is-list article {
    grid-template-columns: 1fr;
  }
}

.ub-block-post-grid .is-list .ub-block-post-grid-image {
  margin-bottom: 0;
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-list .ub-block-post-grid-image {
    width: 30%;
    display: inline-block;
    vertical-align: top;
  }
}

@media only screen and (max-width: 600px) {
  .ub-block-post-grid .is-list .ub-block-post-grid-image {
    margin-bottom: 5%;
  }
}

@media all and (-ms-high-contrast: none) {
  .ub-block-post-grid .is-list .ub-block-post-grid-text {
    width: 65%;
    padding-left: 5%;
    display: inline-block;
    vertical-align: top;
  }
  .ub-block-post-grid
    .is-list
    .post:not(.has-post-thumbnail)
    .ub-block-post-grid-text {
    width: 100%;
    padding-left: 0;
  }
}

.ub-block-post-grid .is-list .no-thumb .ub-block-post-grid-text {
  grid-column: span 2;
}

.ub-block-post-grid-image {
  position: relative;
}

.ub-block-post-grid-image:hover .ub-post-grid-no-image-placeholder {
  opacity: 1;
  z-index: 1;
}

.ub-post-grid-no-image-placeholder {
  padding: 40px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  background: #f3f3f4;
  transition: 0.2s ease;
}

.ub-post-grid-no-image-placeholder svg {
  margin-bottom: 10px;
}

.ub-post-grid-no-image-icon {
  position: absolute;
  top: 10px;
  background: #ffe606;
  right: 10px;
  padding: 6px;
  line-height: 1;
  height: 32px;
  transition: 0.2s ease;
  border-radius: 5px;
  z-index: 1;
}

.ub_progress-bar {
  overflow: auto;
}

.ub_progress-bar-container {
  text-align: start;
}

.ub_progress-bar-circle {
  position: absolute;
}

.ub_progress-bar-circle + .ub_progress-bar-label {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin: auto;
  text-align: center;
}

.ub_progress-bar-circle-trail {
  stroke-dashoffset: 0px;
  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,
    stroke 0.3s ease 0s;
  fill-opacity: 0;
}

.ub_progress-bar-circle-path {
  stroke-dashoffset: 0px;
  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,
    stroke 0.3s ease 0s, stroke-width 0.06s ease 0.3s;
  fill-opacity: 0;
}

.ub_progress-bar-line-trail {
  fill-opacity: 0;
  stroke-linecap: round;
}

.ub_progress-bar-line-path {
  stroke-dasharray: 100px, 100px;
  transition: stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear 0s;
  fill-opacity: 0;
  stroke-linecap: round;
}

.ub_progress-bar-line + .ub_progress-bar-label {
  text-align: right;
  min-width: 24px;
}

.ub_review_block {
  padding: 35px 40px;
  box-shadow: 0px 0px 4px 1px #d6d6d6;
  border-radius: 5px;
  margin: 30px auto;
}

.ub_review_block svg:not(:root) {
  margin: 0 1px;
}

.ub_review_block svg:not(:root):first-child {
  margin-left: 0;
}

.ub_review_block svg:not(:root):last-child {
  margin-right: 0;
}

.ub_review_block .ub_review_image {
  margin-top: 10px;
  float: right;
  object-fit: contain;
}

.ub_review_overall_value {
  display: grid;
  grid-template-columns: 75% 25%;
}

.ub_review_entry,
.ub_review_percentage_entry {
  padding: 10px 0 10px 0;
  border-bottom: 1px solid #e9e9e9;
}

.ub_review_entry {
  display: flex;
}

.ub_review_percentage_entry {
  display: grid;
  grid-template-columns: 25% 75%;
}

.ub_review_rating {
  text-align: right;
  font-size: 40px;
}

.ub_review_average {
  display: flex;
  flex-direction: column;
}

.ub_review_average_stars {
  display: flex;
  grid-area: auto;
  justify-self: self-end;
  height: 50px;
  line-height: 60px;
  margin-left: auto;
  align-items: center;
}

.ub_review_cta_panel {
  display: grid;
  grid-template-columns: 2fr auto;
  grid-template-areas: "cta . stars";
}

.ub_review_add_entry {
  left: 50%;
  width: 100%;
}

.ub_review_link_input {
  display: flex;
  flex-direction: row;
}

.ub_review_cta_btn {
  min-width: 100px;
  padding: 15px 10px;
  border-radius: 6px;
  display: inline-block;
  border-width: 1px;
  border-style: solid;
  text-align: center;
  text-transform: none;
  cursor: pointer;
  font-weight: normal;
  background-image: none;
}

.ub_review_cta_btn:hover,
.ub_review_cta_btn:active {
  background-image: none;
}

.ub_review_item_name {
  font-size: 28px !important;
  margin: 0 !important;
  font-weight: 600 !important;
}

.ub_review_summary_title {
  margin: 23px 0 13px 0 !important;
  font-size: 24px !important;
  font-weight: 600 !important;
}

.ub_review_stars {
  display: flex;
  margin-left: auto;
  padding-top: 3px;
}

.ub_review_description {
  padding: 0;
}

.ub_review_description_container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  overflow: auto;
}

.ub_review_left_image {
  flex-direction: row;
}

.ub_review_right_image {
  flex-direction: row-reverse;
}

.ub_review_top_image {
  flex-direction: column;
}

.ub_review_bottom_image {
  flex-direction: column-reverse;
}

.ub_review_percentage {
  display: grid;
  grid-template-columns: 4fr 1fr;
  overflow: auto;
  margin-left: auto;
}

.ub_review_percentage > svg {
  height: 10px;
}

.ub_review_percentage > div {
  text-align: end;
}

.ub_review_percentage_bar {
  width: 100%;
  align-self: center;
}

.ub_review_percentage_bar_trail {
  fill-opacity: 0;
  stroke-linecap: round;
}

.ub_review_percentage_bar_path {
  stroke-dasharray: 100px, 100px;
  transition: stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear 0s;
  fill-opacity: 0;
  stroke-linecap: round;
}

.ub_review_cta_main {
  display: flex;
}

@media (max-width: 7688px) {
  .ub_review_block {
    padding: 35px 40px;
  }
}

@media (max-width: 576px) {
  .ub_review_cta_btn {
    padding: 15px 10px;
  }
  .ub_review_image {
    float: right;
  }
}

@media (max-width: 480px) {
  .ub_review_rating {
    font-size: 20px;
    font-weight: 600;
  }
  .ub_review_entry {
    font-size: 18px;
  }
  .ub_review_cta_btn {
    padding: 15px 8px;
  }
}

@media (max-width: 460px) {
  .ub_review_average_stars svg {
    width: 12px;
    height: 12px;
  }
}

@media (max-width: 375px) {
  .ub_review_block {
    padding: 20px 15px;
  }
  .ub_review_block button > svg {
    width: 12px;
    height: 12px;
  }
}

@media (max-width: 320px) {
  .ub_review_block {
    padding: 20px 10px;
  }
  .ub_review_block button > svg {
    width: 8px;
    height: 8px;
    margin: 0;
  }
  .ub_review_average_stars {
    height: 45px;
    line-height: 40px;
    margin-left: auto;
  }
}

.wp-block-ub-social-share .social-share-icons {
  display: flex;
  flex-wrap: wrap;
}

.wp-block-ub-social-share .social-share-icons .social-share-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 7px;
}

.wp-block-ub-social-share .social-share-icons .social-share-icon.circle {
  box-shadow: 0px 3px 2px gray;
  border-radius: 50%;
}

.wp-block-ub-social-share .social-share-icons .social-share-icon.square {
  box-shadow: 0px 3px 2px gray;
  border-radius: 0%;
}

.wp-block-ub-social-share .social-share-icons .ub-social-share-standalone-icon {
  margin: 12px;
  padding-right: 5px;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-facebook-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-twitter-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-linkedin-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-pinterest-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-reddit-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share
  .social-share-icons
  .ub-social-share-tumblr-container {
  border-width: 1px;
  border-style: solid;
  white-space: nowrap;
  display: flex;
}

.wp-block-ub-social-share .social-share-icons > div {
  display: flex;
  align-items: center;
}

.wp-block-ub-social-share .social-share-icons a {
  text-decoration: none;
}

.align-icons-center {
  justify-content: center;
}

.align-icons-left {
  justify-content: flex-start;
}

.align-icons-right {
  justify-content: flex-end;
}

.ub-social-share-facebook.square,
.ub-social-share-facebook.circle {
  background-color: #1877f2;
}

.ub-social-share-facebook + span,
.ub-social-share-facebook + span > a {
  color: #1877f2;
}

.ub-social-share-twitter.square,
.ub-social-share-twitter.circle {
  background-color: #1d9bf0;
}

.ub-social-share-twitter + span,
.ub-social-share-twitter + span > a {
  color: #1d9bf0;
}

.ub-social-share-linkedin.square,
.ub-social-share-linkedin.circle {
  background-color: #2867b2;
}

.ub-social-share-linkedin + span,
.ub-social-share-linkedin + span > a {
  color: #2867b2;
}

.ub-social-share-pinterest.square,
.ub-social-share-pinterest.circle {
  background-color: #e60023;
}

.ub-social-share-pinterest + span,
.ub-social-share-pinterest + span > a {
  color: #e60023;
}

.ub-social-share-reddit.square,
.ub-social-share-reddit.circle {
  background-color: #ff4500;
}

.ub-social-share-reddit + span,
.ub-social-share-reddit + span > a {
  color: #ff4500;
}

.ub-social-share-tumblr.square,
.ub-social-share-tumblr.circle {
  background-color: #001935;
}

.ub-social-share-tumblr + span,
.ub-social-share-tumblr + span > a {
  color: #001935;
}

.ub-star-outer-container {
  display: flex;
}

.ub-star-inner-container,
.ub-star-container {
  display: flex;
  flex-direction: row;
  margin: 20px 0;
}

.ub-star-inner-container svg {
  margin-top: initial;
}

.ub-notification-box {
  margin: 10px 0px;
  padding: 15px;
  border-left-width: 4px;
  border-left-style: solid;
}

.ub-notification-box > *:first-child {
  margin-top: 0;
}

.ub-notification-box > *:last-child {
  margin-bottom: 0;
}

.ub-feature-box,
.ub-number-box {
  display: flex;
  margin-top: 60px;
  margin-bottom: 30px;
}

.ub-feature-box > div,
.ub-number-box > div {
  flex-basis: 100%;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  padding: 1rem;
}

.ub-feature-box > div:first-child:nth-last-child(3),
.ub-number-box > div:first-child:nth-last-child(3) {
  margin-left: 0;
}

.ub-feature-box > div:last-child:nth-child(3),
.ub-number-box > div:last-child:nth-child(3) {
  margin-right: 0;
}

.ub-number-panel {
  border: 1px solid;
}

.ub-number-box .ub-number-panel .ub-number-container {
  border-radius: 100px;
  overflow: hidden;
  border: medium none;
  max-width: 80px;
  margin: -60px auto 25px;
}

.ub-number-box .ub-number-panel .ub-number-container .ub-number-display {
  font-size: 40px;
  text-align: center;
  line-height: 80px;
  margin: 0 auto;
}

.ub-number-box .ub-number-panel .ub-number-box-title {
  font-size: 30px;
  text-align: center;
  margin: 10px auto;
  padding: 0;
}

.ub-feature-box .ub-feature img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.ub-feature-box .ub-feature .ub-feature-title {
  font-size: 30px;
  text-align: center;
  margin: 20px 0;
  padding: 0;
}

.ub-bordered-box {
  margin-bottom: 20px;
  padding: 20px;
}

.ub-bordered-box > p:last-child {
  margin: 0;
}

@media screen and (max-width: 800px) {
  .ub-feature-box,
  .ub-number-box {
    display: block;
  }
  .ub-feature-box > div,
  .ub-number-box > div {
    width: 90%;
    margin: 0;
  }
}

.ub_styled_list .fa-ul {
  list-style-type: none;
  margin-left: 1em;
  padding-left: 0;
  display: grid;
  column-gap: 2em;
}

.ub_styled_list .fa-ul > li {
  position: relative;
  list-style: none;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.ub_styled_list .fa-li {
  display: inline-block;
  left: -0.5em;
  position: relative;
}

.ub_styled_list li::before {
  content: "";
  position: relative;
  left: -0.5em;
  display: inline-block;
  background-repeat: no-repeat;
}

ul.ub_styled_list {
  list-style-type: none;
  margin-left: 1em;
  padding-left: 0;
}

ul.ub_styled_list li {
  position: relative;
  list-style: none;
  margin-left: 0.5em;
  margin-right: 0.5em;
}

.ub-hide {
  display: none;
}

.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ub-toggle-transition {
  transition: all 0.5s ease-in-out;
}

.ub-icon-holder {
  position: relative;
  transform: translate(-25%, 25%);
}

.ub-custom-id-input {
  font-size: 0.9em;
}

@media (max-width: 699px) {
  .ub-mobile-hide {
    display: none;
  }
  .ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tablet-hide {
    display: none;
  }
  .ub-tablet-display {
    display: block;
  }
}

.wp-block-ub-tabbed-content {
  margin-top: 30px;
  margin-bottom: 30px;
}

.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tabs-content {
  border: 1px solid #d3d3d3;
}

.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tab-title-wrap {
  border: 1px solid #d3d3d3;
  border-bottom: 0;
}

.wp-block-ub-tabbed-content-holder .blocks-rich-text__tinymce.mce-content-body {
  font-size: 14px;
}

.wp-block-ub-tabbed-content-holder.vertical-holder {
  display: flex;
}

.wp-block-ub-tabbed-content-tab-holder {
  position: relative;
}

.wp-block-ub-tabbed-content-tab-holder.vertical-tab-width {
  position: relative;
  width: 21%;
}

.wp-block-ub-tabbed-content-tabs-title {
  display: flex;
  overflow-x: hidden;
}

.wp-block-ub-tabbed-content-tabs-title:hover,
.wp-block-ub-tabbed-content-tabs-title:focus {
  overflow-x: auto;
}

@media (max-width: 699px) {
  .wp-block-ub-tabbed-content-tabs-title.ub-mobile-hide {
    display: none;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .wp-block-ub-tabbed-content-tabs-title.ub-tablet-hide {
    display: none;
  }
}

.wp-block-ub-tabbed-content-tabs-content {
  padding: 25px;
}

.wp-block-ub-tabbed-content-tabs-content.vertical-content-width {
  width: 79%;
}

.wp-block-ub-tabbed-content-tab-title {
  word-break: initial;
}

.wp-block-ub-tabbed-content-tab-title-wrap {
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  padding: 10px 15px;
  margin-right: 5px;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.wp-block-ub-tabbed-content-tab-title-wrap.active {
  color: #fff;
}

.wp-block-ub-tabbed-content-tab-title-vertical-wrap {
  border: 1px solid #d3d3d3;
  border-top-left-radius: 5px;
  padding: 10px 15px;
  border-right: 0;
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active {
  color: #000;
}

@media (max-width: 699px) {
  .ub-tabbed-content-mobile-accordion {
    padding: 0;
    border: none;
  }
  .ub-tabbed-content-mobile-accordion
    > .wp-block-ub-tabbed-content-tab-content-wrap {
    border: 1px solid #d3d3d3;
    padding: 20px;
  }
  .ub-tabbed-content-mobile-accordion
    > .wp-block-ub-tabbed-content-tab-content-wrap.active {
    border-color: #a9a9a9;
  }
  .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap {
    border: 1px solid #d3d3d3;
    border-top-left-radius: 5px;
    padding: 10px 15px;
    border-right: 0;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }
  .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap.active {
    color: #000;
  }
  .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-mobile {
    width: 79%;
  }
  .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-mobile {
    width: 100;
  }
  .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-mobile {
    width: 21%;
  }
  .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-mobile {
    width: 100%;
  }
  .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab {
    display: initial;
  }
  .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab
    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
    border-bottom: 1px solid #d3d3d3;
  }
  .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab {
    display: flex;
  }
  .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab
    .wp-block-ub-tabbed-content-tab-title-vertical-wrap {
    border-right: 1px solid #d3d3d3;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile {
    display: block;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile
    > .wp-block-ub-tabbed-content-tabs-content {
    width: 100%;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-mobile {
    display: flex;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tabbed-content-tablet-accordion {
    padding: 0;
    border: none;
  }
  .ub-tabbed-content-tablet-accordion
    > .wp-block-ub-tabbed-content-tab-content-wrap {
    border: 1px solid #d3d3d3;
    padding: 20px;
  }
  .ub-tabbed-content-tablet-accordion
    > .wp-block-ub-tabbed-content-tab-content-wrap.active {
    border-color: #a9a9a9;
  }
  .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
    border: 1px solid #d3d3d3;
    border-top-left-radius: 5px;
    padding: 10px 15px;
    border-right: 0;
    display: flex;
    align-items: center;
    position: relative;
    cursor: pointer;
  }
  .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap.active {
    color: #000;
  }
  .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-tablet {
    width: 79%;
  }
  .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-tablet {
    width: 100%;
  }
  .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-tablet {
    width: 21%;
  }
  .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-tablet {
    width: 100%;
  }
  .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab {
    display: initial;
  }
  .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab
    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {
    border-bottom: 1px solid #d3d3d3;
  }
  .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab {
    display: flex;
  }
  .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab
    .wp-block-ub-tabbed-content-tab-title-vertical-wrap {
    border-right: 1px solid #d3d3d3;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet {
    display: block;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet
    > .wp-block-ub-tabbed-content-tabs-content {
    width: 100%;
  }
  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-tablet {
    display: flex;
  }
}

.wp-block-ub-tabbed-content-accordion-toggle {
  border: 1px solid #d3d3d3;
  padding: 10px 15px;
  display: none;
}

.wp-block-ub-tabbed-content-accordion-toggle.active {
  border-bottom: none;
}

@media (max-width: 699px) {
  .wp-block-ub-tabbed-content-accordion-toggle.ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .wp-block-ub-tabbed-content-accordion-toggle.ub-tablet-display {
    display: block;
  }
}

@media (max-width: 374.98px) {
  .wp-block-ub-tabbed-content-tab-title-wrap {
    padding: 10px 5px;
  }
  .wp-block-ub-tabbed-content-tabs-content {
    padding: 10px;
  }
  .wp-block-ub-tabbed-content-tabs-content p {
    margin: 0 0 10px 0;
  }
  .wp-block-ub-tabbed-content-scroll-button-container > button {
    top: -30px;
  }
}

.ub-hide {
  display: none;
}

.ub-hiding {
  height: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  margin-bottom: 0;
}

.ub-toggle-transition {
  transition: all 0.5s ease-in-out;
}

.ub-icon-holder {
  position: relative;
  transform: translate(-25%, 25%);
}

.ub-custom-id-input {
  font-size: 0.9em;
}

@media (max-width: 699px) {
  .ub-mobile-hide {
    display: none;
  }
  .ub-mobile-display {
    display: block;
  }
}

@media (min-width: 700px) and (max-width: 899px) {
  .ub-tablet-hide {
    display: none;
  }
  .ub-tablet-display {
    display: block;
  }
}

.ub_table-of-contents {
  box-sizing: border-box;
  transition: all 0.5s ease-in-out;
  background-color: #fafafa;
  border: 1px solid #dfdfdf;
  padding: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
  display: grid;
}

.ub_table-of-contents ul,
.ub_table-of-contents ol {
  margin-bottom: 0;
  margin-left: 1.3em;
  padding-inline-start: 0;
  padding-left: 0;
}

.ub_table-of-contents ol {
  list-style-type: none;
  counter-reset: item;
  margin: 0;
  padding: 0;
}

.ub_table-of-contents ol > li {
  display: table;
  counter-increment: item;
}

.ub_table-of-contents ol > li:before {
  content: counters(item, ".") ". ";
  display: table-cell;
  padding-right: 0.6em;
}

.ub_table-of-contents li ol > li {
  margin: 0;
}

.ub_table-of-contents li ol > li:before {
  content: counters(item, ".") " ";
}

.ub_table-of-contents-header {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  display: grid;
  grid-template-columns: minmax(10px, 1fr) auto;
  transition: all 0.5s ease-in-out;
}

.ub_table-of-contents-header-toggle {
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.ub_table-of-contents-collapsed {
  padding: 10px;
}

.ub_table-of-contents-1-column {
  column-count: 1;
}

.ub_table-of-contents-2-column {
  column-count: 2;
}

.ub_table-of-contents-3-column {
  column-count: 3;
}

.ub_table-of-contents-container {
  transition: all 0.5s ease-in-out;
  overflow: hidden;
}

.ub_table-of-contents .ub_table-of-contents-container ul > li:before {
  content: none;
}

.ub_table-of-contents-header-container,
.ub_table-of-contents-extra-container {
  padding: 15px 30px;
  transition: all 0.5s ease-in-out;
}

.ub_table-of-contents-header-container {
  display: grid;
}

.ub_table-of-contents,
.ub_table-of-contents-collapsed {
  padding: 0;
}

.ub_table-of-contents-collapsed .ub_table-of-contents-extra-container {
  padding: 0;
}

@media screen and (max-width: 600px) {
  .ub_table-of-contents-1-column,
  .ub_table-of-contents-2-column,
  .ub_table-of-contents-3-column {
    column-count: 1;
  }
}

.wp-block-ub-testimonial-block {
  margin: 30px auto;
  max-width: 100%;
}

.ub_testimonial {
  max-width: 100%;
  padding: 30px;
  display: grid;
  grid-template-columns: fit-content(25%) auto;
  grid-template-rows: auto auto;
  margin: 40px 0;
}

.ub_testimonial_img {
  padding: 10px 10px;
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row-end: span 2;
}

.ub_testimonial_img img {
  margin: 0 auto;
  padding: 0;
  border-radius: 50%;
}

.ub_testimonial_content {
  grid-row-start: 1;
  grid-column-start: 2;
  padding: 11px 20px;
}

.ub_testimonial_content p {
  font-style: italic;
}

.ub_testimonial_sign {
  padding-right: 10px;
  padding-bottom: 10px;
  grid-column-start: 2;
  grid-row-start: 2;
}

.ub_testimonial_sign p {
  margin-bottom: 2px !important;
}

.ub_testimonial_sign .ub_testimonial_author_role {
  margin-top: 0;
  font-size: 13px;
  font-style: italic;
}

@media (max-width: 479.98px) {
  .ub_testimonial {
    padding: 30px 10px;
    display: block;
  }
  .ub_testimonial_img {
    padding: 0;
  }
  .ub_testimonial_content {
    padding: 10px;
  }
  .ub_testimonial_content p {
    text-align: center !important;
  }
  .ub_testimonial_sign {
    padding-right: 0;
  }
  .ub_testimonial_sign .ub_testimonial_author_role {
    text-align: center !important;
    margin-top: 5px;
  }
  .ub_testimonial_img,
  .ub_testimonial_author {
    text-align: center !important;
  }
}

@media (max-width: 320px) {
  .ub_testimonial_content {
    padding: 10px 0;
  }
}

.ultimate-blocks-icon-component {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ultimate-blocks-icon-component .ultimate-blocks-icon-component-svg-base {
  width: 100%;
  height: 100%;
}

@keyframes linearGradientMove {
  to {
    background-position: 6px 0, -6px 100%, 0 -6px, 100% 6px;
  }
}

.wp-block-ub-tabbed-content-tab-title-wrap,
.wp-block-ub-tabbed-content-tab-title-vertical-wrap {
  background-color: inherit;
  border-color: lightgrey;
  color: inherit;
}

.wp-block-ub-tabbed-content-tab-title-wrap.active,
.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active,
.wp-block-ub-tabbed-content-accordion-toggle.active {
  background-color: #13294b;
  color: #ffffff;
}

.wp-block-ub-tabbed-content-accordion-toggle.active {
  background-color: #13294b;
}

.wp-block-ub-tabbed-content-tabs-title {
  justify-content: flex-start;
}

.wp-block-ub-tabbed-content-accordion-toggle {
  background-color: transparent;
  color: inherit;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(1) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(2) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(3) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(4) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(5) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(6) {
  text-align: left;
}

.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(7) {
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB;sBACoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B;sBACoB;AACtB;;AAEA;EACE,uBAAuB;EACvB;sBACoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B;sBACoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B;sBACoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,wBAAwB;EACxB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,SAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;;;;;;;;EAaE,cAAc;AAChB;AACA;;;;EAIE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,qCAAqC;AACvC;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;;;;EAIE,iCAAiC;EACjC,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;;;;;EAKE,aAAa;EACb,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;;;;EAIE,0BAA0B;AAC5B;AACA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;AACA;;EAEE,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EAEpB,yDAAyD;EAEzD,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;;EAE5B,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;;EAE5B,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;;EAEb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;;EAEtB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,gCAAgC;EAChC,YAAY;EACZ,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,8CAA8C;EAC9C,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;EAC7B,kCAAkC;EAClC,iCAAiC;EACjC,qCAAqC;EACrC,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;EAEE,uCAAuC;EACvC,kBAAkB;EAClB;gDAC8C;EAC9C,UAAU;EACV,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;;;;EAIE,sBAAsB;EACtB,YAAY;AACd;AACA;;;;EAIE,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAO;AACT;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;;EAElB,sEAAsE;AACxE;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,4BAA4B;AAC9B;AAaA;EACE;IAEE,0CAA0C;EAC5C;EACA;IAEE,2CAA2C;EAC7C;EACA;IAEE,wCAAwC;EAC1C;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,gDAAgD;EAChD,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,sDAAsD;AACxD;;AAEA,qFAAqF;AACrF;EACE,mBAAmB;EAEnB,oBAAoB;AACtB;;AAEA,sCAAsC;;AAUtC;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2CAA2C;;AAE3C;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,YAAY;AACd;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;AACA;EAIE,qBAAqB;EAGrB,iBAAiB;EACjB,aAAa;EACb,UAAU;EACV,cAAc;EACd,yBAAyB;EACzB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;AACA;;;;EAIE,aAAa;AACf;AACA;;;;EAIE,aAAa;AACf;AACA;EACE,oCAAoC;AACtC;AACA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,iBAAiB;AACnB;AACA;EACE;IACE,cAAc;IACd,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EAIb,8BAA8B;EAG9B,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;;EAEjB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;;EAEA;EACA;AACF;AACA;EACE;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,cAAc;EAChB;AACF;;AAEA;AACA;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;EAEE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,6BAA6B;EAC7B,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,4BAA4B;EAC5B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;;EAGE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;EAME,qBAAqB;AACvB;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;EACT,QAAQ;AACV;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB;qDACmD;EACnD,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;;;;IAME,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;;IAKE,aAAa;IACb,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,oBAAoB;EACtB;EACA;;;;;IAKE,0BAA0B;EAC5B;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;;;;;;IAOE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;IAGE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;;;;;IAKE,SAAS;IACT,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;;IAIE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;;EAIE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B;kBACgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,4BAA4B;AAC9B;;AAEA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE;;;;GAIC;AACH;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,oDAAoD;EACpD,qCAAqC;EACrC,yDAAyD;EACzD,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gEAAgE;AAClE;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,wCAAwC;EACxC,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,OAAO;EACP,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,qEAAqE;AACvE;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,oCAAoC;AACtC;;AAEA;;;EAGE,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;;EAGE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;;;EAGE,uCAAuC;AACzC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,qEAAqE;EACrE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,OAAO;EACP,MAAM;AACR;;AAEA;;;EAGE,UAAU;EACV,YAAY;EACZ,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;EAIE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EAER,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;;;EAGE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;EAGE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;EACrB;EACA;;;;IAIE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;uBACqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB;qDACmD;EACnD,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iEAAiE;EACjE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iEAAiE;EACjE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,WAAW;IACX,SAAS;EACX;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;;IAEE,cAAc;EAChB;EACA;;IAEE,UAAU;IACV,SAAS;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;;IAEE,yBAAyB;IACzB,aAAa;EACf;EACA;;IAEE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;IACV,YAAY;EACd;EACA;;IAEE,yBAAyB;IACzB,aAAa;EACf;EACA;;IAEE,qBAAqB;EACvB;EACA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,aAAa;EACf;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;EAChC,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,6CAA6C;EAC7C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;;IAGE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,4CAA4C;EAC5C,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,6BAA6B;IAC7B,eAAe;EACjB;EACA;;IAEE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,uDAAuD;EACzD;AACF;;AAEA;;EAEE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[":root {\n  --illiniOrange: #ff552e;\n  --illiniDarkBlue: #13294b;\n  --backgroundGrey: #e5e5e5;\n  --darkGrey: #f2f2f2;\n  --cloudGrey: #f8f8f8;\n  --lightGrey: #d6d6d6;\n  --middleGrey: #e4e4e4;\n  --darkestGrey: #6d6d6d;\n  --white: #fff;\n}\n\n@font-face {\n  font-family: Monsterrat;\n  src: url(\"../src/components/Common/Fonts/Montserrat/Montserrat-Bold.ttf\")\n    format(\"truetype\");\n}\n\n@font-face {\n  font-family: Monsterrat Bold;\n  src: url(\"../src/components/Common/Fonts/Montserrat/Montserrat-ExtraBold.ttf\")\n    format(\"truetype\");\n}\n\n@font-face {\n  font-family: Fjalla_One;\n  src: url(\"../src/components/Common/Fonts/Fjalla_One/FjallaOne-Regular.ttf\")\n    format(\"truetype\");\n}\n\n@font-face {\n  font-family: Source Sans Pro;\n  src: url(\"../src/components/Common/Fonts/Source_Sans_Pro/SourceSansPro-Regular.ttf\")\n    format(\"truetype\");\n}\n\n@font-face {\n  font-family: Source Serif Pro;\n  src: url(\"../src/components/Common/Fonts/Source_Serif_Pro/SourceSerifPro-Regular.ttf\")\n    format(\"truetype\");\n}\n\nhtml {\n  font-family: \"Source Sans Pro\";\n  -ms-text-size-adjust: 100%;\n  -webkit-text-size-adjust: 100%;\n}\nbody {\n  margin: 0;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nmain {\n  flex: 1 1;\n  background: var(--white);\n  width: 100%;\n  margin: 0 auto;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  padding: 0rem 1rem 0rem 1rem;\n}\n\n.form-control {\n  width: 250px;\n  position: relative;\n  height: 2.5rem;\n  appearance: none;\n  text-indent: 1px;\n  box-sizing: border-box;\n  flex: 1 0 0%;\n  background: transparent;\n  padding-left: 0.5rem;\n  border-radius: 4px;\n  border: 1px solid grey;\n}\n\n.mainWrapper {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.whiteText {\n  color: #fff;\n}\n\nh2,\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\nprogress {\n  vertical-align: baseline;\n}\n[hidden],\ntemplate {\n  display: none;\n}\na {\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\na:active,\na:hover {\n  outline-width: 0;\n}\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  text-decoration: underline dotted;\n}\nb,\nstrong {\n  font-weight: inherit;\n  font-weight: bolder;\n}\ndfn {\n  font-style: italic;\n}\nh1 {\n  font-family: \"Monsterrat\";\n  font-weight: 700;\n  font-size: 2em;\n  margin: 0.67em 0;\n}\nmark {\n  background-color: #ff0;\n  color: #000;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\nimg {\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace;\n  font-size: 1em;\n}\nfigure {\n  margin: 1em 40px;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0;\n}\noptgroup {\n  font-weight: 700;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\n[type=\"reset\"],\n[type=\"submit\"],\nbutton,\nhtml [type=\"button\"] {\n  -webkit-appearance: button;\n}\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner,\nbutton::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring,\nbutton:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\nfieldset {\n  border: 1px solid silver;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em;\n}\nlegend {\n  box-sizing: border-box;\n  color: inherit;\n  display: table;\n  max-width: 100%;\n  padding: 0;\n  white-space: normal;\n}\ntextarea {\n  overflow: auto;\n}\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-input-placeholder {\n  color: inherit;\n  opacity: 0.54;\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button;\n  font: inherit;\n}\nhtml {\n  font: 112.5%/1.45em arial, georgia, serif;\n  box-sizing: border-box;\n  overflow-y: scroll;\n}\n* {\n  box-sizing: inherit;\n}\n*:before {\n  box-sizing: inherit;\n}\n*:after {\n  box-sizing: inherit;\n}\nbody {\n  color: hsla(0, 0%, 0%, 0.8);\n  font-family: \"arial\", georgia, serif;\n  font-weight: normal;\n  word-wrap: break-word;\n  font-kerning: normal;\n  -moz-font-feature-settings: \"kern\", \"liga\", \"clig\", \"calt\";\n  -ms-font-feature-settings: \"kern\", \"liga\", \"clig\", \"calt\";\n  -webkit-font-feature-settings: \"kern\", \"liga\", \"clig\", \"calt\";\n  font-feature-settings: \"kern\", \"liga\", \"clig\", \"calt\";\n}\nimg {\n  max-width: 100%;\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\n\na {\n  text-decoration: none;\n  color: #000;\n}\n\np {\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 1.1rem;\n  line-height: 1.7rem;\n}\n\nh1 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 2.2rem;\n  line-height: 40px;\n  color: var(--illiniDarkBlue);\n\n  width: 100%;\n}\n\nh2 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 2rem;\n  line-height: 40px;\n  color: var(--illiniDarkBlue);\n\n  width: 100%;\n}\nh3 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 1.5rem;\n  line-height: 40px;\n  color: var(--illiniDarkBlue);\n  margin-top: 0;\n\n  width: 100%;\n}\nh4 {\n  font-family: Arial;\n  font-weight: 800;\n  font-size: 1.2rem;\n  letter-spacing: 1px;\n}\nh5 {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 1rem;\n  font-style: normal;\n  font-variant: normal;\n  font-weight: 200;\n  letter-spacing: 1px;\n  margin-bottom: 10px;\n  color: #000;\n  text-transform: uppercase;\n}\nh6 {\n  font-family: \"Times New Roman\";\n  font-size: 28px;\n  color: #fff;\n  font-style: italic;\n  margin: 40px 20% 20px 20%;\n  line-height: 35px;\n}\nhgroup {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nul {\n  margin-left: 1.45rem;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n  list-style-position: outside;\n  list-style-image: none;\n\n  width: 100%;\n}\n\nol {\n  margin-left: 1.45rem;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n  list-style-position: outside;\n  list-style-image: none;\n}\ndl {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\ndd {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\np {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nfigure {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\npre {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  margin-bottom: 1.45rem;\n  font-size: 0.85rem;\n  line-height: 1.42;\n  background: hsla(0, 0%, 0%, 0.04);\n  border-radius: 3px;\n  overflow: auto;\n  word-wrap: normal;\n  padding: 1.45rem;\n}\ntable {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n  font-size: 1rem;\n  line-height: 1.45rem;\n  border-collapse: collapse;\n  width: 100%;\n}\nfieldset {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nblockquote {\n  margin-left: 1.45rem;\n  margin-right: 1.45rem;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nform {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nnoscript {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\niframe {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nhr {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: calc(1.45rem - 1px);\n  background: hsla(0, 0%, 0%, 0.2);\n  border: none;\n  height: 1px;\n}\naddress {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n  padding-bottom: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-top: 0;\n  margin-bottom: 1.45rem;\n}\nb {\n  font-weight: bold;\n}\nstrong {\n  font-weight: bold;\n}\ndt {\n  font-weight: bold;\n}\nth {\n  font-weight: bold;\n}\nli {\n  margin-bottom: 0;\n}\nol li {\n  padding-left: 0;\n}\nul li {\n  padding-left: 0;\n}\nli > ol {\n  margin-left: 1.45rem;\n  margin-top: calc(1.45rem / 2);\n}\nli > ul {\n  margin-left: 1.45rem;\n  margin-top: calc(1.45rem / 2);\n}\nblockquote *:last-child {\n  margin-bottom: 0;\n}\nli *:last-child {\n  margin-bottom: 0;\n}\np *:last-child {\n  margin-bottom: 0;\n}\nli > p {\n  margin-bottom: calc(1.45rem / 2);\n}\ncode {\n  font-size: 0.85rem;\n  line-height: 1.45rem;\n}\nkbd {\n  font-size: 0.85rem;\n  line-height: 1.45rem;\n}\nsamp {\n  font-size: 0.85rem;\n  line-height: 1.45rem;\n}\nabbr {\n  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n  cursor: help;\n}\nacronym {\n  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n  cursor: help;\n}\nabbr[title] {\n  border-bottom: 1px dotted hsla(0, 0%, 0%, 0.5);\n  cursor: help;\n  text-decoration: none;\n}\nthead {\n  text-align: left;\n}\ntd,\nth {\n  text-align: left;\n  border-bottom: 1px solid hsla(0, 0%, 0%, 0.12);\n  font-feature-settings: \"tnum\";\n  -moz-font-feature-settings: \"tnum\";\n  -ms-font-feature-settings: \"tnum\";\n  -webkit-font-feature-settings: \"tnum\";\n  padding-left: 0.96667rem;\n  padding-right: 0.96667rem;\n  padding-top: 0.725rem;\n  padding-bottom: calc(0.725rem - 1px);\n}\n\ntt,\ncode {\n  background-color: hsla(0, 0%, 0%, 0.04);\n  border-radius: 3px;\n  font-family: \"SFMono-Regular\", Consolas, \"Roboto Mono\", \"Droid Sans Mono\",\n    \"Liberation Mono\", Menlo, Courier, monospace;\n  padding: 0;\n  padding-top: 0.2em;\n  padding-bottom: 0.2em;\n}\npre code {\n  background: none;\n  line-height: 1.42;\n}\ncode:before,\ncode:after,\ntt:before,\ntt:after {\n  letter-spacing: -0.2em;\n  content: \" \";\n}\npre code:before,\npre code:after,\npre tt:before,\npre tt:after {\n  content: \"\";\n}\n\n.submitButton {\n}\n\n.submitButton:hover {\n  color: var(--white) !important;\n  background: var(--illiniDarkBlue) !important;\n}\n.primaryTitle {\n  font-family: \"Monsterrat\";\n  font-weight: 800;\n  font-size: 3rem;\n  line-height: 3rem;\n  color: var(--illiniDarkBlue);\n}\n.secondaryTitle {\n  font-family: \"Monsterrat\";\n  font-weight: 800;\n  font-size: 2.5rem;\n  color: var(--illiniDarkBlue);\n  line-height: 2.5rem;\n}\n.tertiaryTitle {\n  font-family: \"Source Sans Pro\";\n  font-weight: 600;\n  font-size: 2rem;\n  color: var(--illiniDarkBlue);\n}\n.headline {\n  font-family: \"Source Sans Pro\";\n  font-weight: 700;\n  font-size: 1.5rem;\n  color: var(--illiniDarkBlue);\n  font-style: normal;\n}\n.paragraphLarge {\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  color: var(--darkestGrey);\n}\n.paragraphSmall {\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  color: var(--darkestGrey);\n}\n\n.paragraph {\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  color: var(--darkestGrey);\n}\n.paragraphSmallBlue {\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  color: var(--illiniDarkBlue);\n}\n.primaryLabel {\n  font-family: \"Monsterrat\";\n  font-weight: 800;\n  font-size: 1rem;\n  font-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--illiniDarkBlue);\n}\n.secondaryLabel {\n  font-family: \"Monsterrat\";\n  font-weight: 800;\n  font-size: 1rem;\n  font-spacing: 1.5px;\n  text-transform: uppercase;\n  color: var(--illiniOrange);\n}\n.detail {\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  color: var(--darkestGrey);\n}\n.primaryLinkLarge {\n  font-family: \"Source Sans Pro\";\n  font-weight: 700;\n  font-size: 1.25rem;\n  color: var(--illiniDarkBlue);\n}\n.primaryLink {\n  font-family: \"Source Sans Pro\";\n  font-weight: 700;\n  font-size: 1rem;\n}\n.secondaryLink {\n  font-family: \"Source Sans Pro\";\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--illiniDarkBlue);\n}\n.unitTitleLarge {\n  font-family: \"Source Sans Pro\";\n  font-weight: 700;\n  font-size: 1.5rem;\n  color: var(--illiniDarkBlue);\n}\n.unitTitleSmall {\n  font-family: \"Source Sans Pro\";\n  font-weight: 700;\n  font-size: 1rem;\n  color: var(--illiniDarkBlue);\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.wp-block-video {\n  max-width: 100%;\n}\n\nvideo {\n  max-width: 100%;\n}\n\n.wp-block-code {\n  display: none;\n}\n\niframe {\n  width: 100%;\n}\n\n.rightTop {\n  margin-top: 6rem;\n}\n\n.pageImage {\n  margin-bottom: 1rem;\n}\n\n.rowWrapper {\n  width: 100%;\n  display: flex;\n  flex: 1;\n}\n\n/* THE FOLLOWING LINES COULD GO INTO STYLED.JS FILES LATER */\n.wizard li {\n  color: #000;\n  display: inline-block;\n  position: relative;\n  background: #ccc;\n  padding: 15px 0;\n  width: 300px;\n  text-align: center;\n  margin: 2px;\n}\n\n.wizard li:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  left: 0;\n  top: 100%;\n  width: 0;\n  height: 0;\n}\n\n.wizard li.inprogress {\n  color: #fff;\n  background: #337ab7;\n  height: 120px;\n  padding: 20px;\n  text: \"Inpogress\";\n}\n\n.wizard li.inprogress:after {\n  border-top: 20px solid #337ab7;\n  border-right: 150px solid transparent;\n  border-bottom: 0 solid transparent;\n  border-left: 150px solid transparent;\n}\n\n.wizard li.complete {\n  color: #fff;\n  background: #8d8d8d;\n}\n\n.wizard li.complete:after {\n  border-top: 0px;\n}\n\n.circle {\n  margin: 10px;\n  border-radius: 50%;\n  width: 75px;\n  height: 75px;\n  padding: 4px;\n  border: 2px solid #ccc;\n  color: #fff;\n  text-align: center;\n\n  /*  width: 100px; height: 100px; background: red; border-radius: 50% */\n}\n\n.circle-active {\n  background-color: #28a745;\n  cursor: pointer;\n  animation: pulse 2s infinite;\n}\n\n.circle {\n  border-radius: 50%;\n  width: 35px;\n  height: 35px;\n  padding: 4px;\n  color: #fff;\n  margin: 5px;\n}\n\n.circle.active {\n  background: #0d6efd;\n}\n\n.circle.inactive {\n  background: #6c757d;\n}\n\n.circle.complete {\n  background: #000;\n}\n\n.circles-active {\n  background-color: #28a745;\n  cursor: pointer;\n  animation: pulse 2s infinite;\n}\n\n@-webkit-keyframes pulse {\n  0% {\n    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n  }\n  70% {\n    -webkit-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n  }\n  100% {\n    -webkit-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n@keyframes pulse {\n  0% {\n    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n  }\n  70% {\n    -moz-box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n  }\n  100% {\n    -moz-box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n\n/* Popup container */\n.popup {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n/* The actual popup (appears on top) */\n.popup .popuptext {\n  visibility: show;\n  width: 160px;\n  background-color: #555;\n  opacity: 0.5;\n  /*background-color: rgba(255, 255, 255, .15);  */\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 8px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -80px;\n  backdrop-filter: blur(5px);\n}\n\n/* Popup arrow */\n.popup .popuptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n/* Toggle this class when clicking on the popup container (hide and show the popup) */\n.popup .show {\n  visibility: visible;\n  -webkit-animation: fadeIn 1s;\n  animation: fadeIn 1s;\n}\n\n/* Add animation (fade in the popup) */\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* FINISH COMMENT STYLED JS --------------*/\n\n.slice {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 50%;\n  height: 50%;\n  transform-origin: 0% 100%;\n}\n\n.breadcrumbBar {\n  color: var(--illiniDarkBlue);\n  width: 1180px;\n  display: flex;\n  padding-top: 1rem;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0 auto;\n  height: 3rem;\n}\n.wp-block-separator {\n  width: 100%;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.rowTeams {\n  width: 100%;\n  min-height: 500px;\n  margin-bottom: 1rem;\n  display: flex;\n  justify-content: space-round;\n}\n.col-sm-4 {\n  width: 33.333%;\n  float: left;\n  position: relative;\n  min-height: 1px;\n}\n.service-item {\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  -webkit-flex-flow: column;\n  -ms-flex-flow: column;\n  flex-flow: column;\n  height: 430px;\n  width: 95%;\n  margin: 0 auto;\n  border: 1px solid #f1f1f1;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  background: white;\n}\n\n.title-wrapper {\n  padding: 3rem 2rem;\n  text-align: center;\n  text-align: center;\n}\n\n.title-wrapper .entry-title {\n  margin: 0 0 0.5rem;\n  font-size: 1.5rem;\n  position: relative;\n  padding-bottom: 0.5rem;\n}\n\n.title-wrapper .entry-content {\n  margin: 0.5rem 0 0;\n}\n\n.teamsInfoHide {\n  display: none;\n}\n\n.teamsInfoShow {\n  display: block;\n  background: white;\n  width: 100%;\n  margin: 0 auto;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-top: 30px;\n}\n\n.hoverLink {\n  text-decoration: none !important;\n  color: inherit;\n  transition: border-color 0.2s ease 0s;\n  color: var(--illiniDarkBlue);\n}\n\n.hoverLink:hover {\n  text-decoration: underline !important;\n}\n.teamsInfoInner {\n  width: 90%;\n  margin: 0 auto;\n}\n\n.optanon-alert-box-wrapper {\n  background-color: rgba(0, 0, 0, 0.8) !important;\n}\n.optanon-alert-box-wrapper\n  .optanon-button-more\n  .optanon-alert-box-button-middle\n  a:before {\n  content: none;\n}\n.optanon-alert-box-wrapper\n  .optanon-button-allow\n  .optanon-alert-box-button-middle\n  a:before {\n  content: none;\n}\n.optanon-alert-box-wrapper .optanon-alert-box-button-middle {\n  background-color: #57802d !important;\n}\n.optanon-alert-box-body a {\n  color: #fff !important;\n  text-decoration: underline !important;\n  padding-left: 5px;\n}\n@media only screen and (max-width: 752px) {\n  .optanon-alert-box-wrapper .optanon-alert-box-bg p {\n    font-size: 9pt;\n    line-height: 12pt;\n  }\n  .optanon-alert-box-bg .optanon-alert-box-button-container {\n    text-align: right;\n    margin-left: 1em;\n  }\n}\n\n.whitebg {\n  background-color: var(--white);\n}\n.container h3 {\n  width: 100%;\n}\n\n.container h4 {\n  width: 100%;\n}\n.wp-block-ub-tabbed-content {\n  max-width: 100%;\n  overflow-x: scroll;\n}\n\n.imgMargin {\n  margin-bottom: 0px;\n  padding-right: 0.5rem;\n}\n\n.whiteTxt {\n  color: var(--white);\n}\n\n.darkBlueTxt {\n  color: var(--illiniDarkBlue);\n}\n\n.greyDarkestTxt {\n  color: var(--darkestGrey);\n}\n\n.module_header {\n  padding-right: 1rem;\n}\n\n.serviceTop {\n  max-width: 800px;\n}\n\n.container ul {\n  list-style: none;\n  color: var(--darkestGrey);\n  font-family: \"Source Sans Pro\";\n  font-weight: 400;\n  font-size: 1rem;\n  text-align: left;\n}\n\n.container li {\n  margin-bottom: 0;\n}\n\n.iconContainer {\n  border-radius: 0.25rem;\n}\n\n.container li::before {\n  content: \"•\";\n  color: var(--illiniOrange);\n  padding-right: 1rem;\n}\n\n.serviceTop h2 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 40px;\n  color: var(--illiniDarkBlue);\n}\n\n.providerImage {\n  margin-bottom: 2rem;\n  width: 500px;\n  height: auto;\n  float: left;\n}\n\n.container {\n  width: 100%;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  display: flex;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-flex-wrap: wrap;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.newsImage {\n  max-width: 100%;\n  height: auto;\n}\n\n.wp-block-ub-tabbed-content-tab-title-vertical-wrap .active {\n  background-color: var(--illiniDarkBlue);\n  color: var(--white);\n}\n\n.newsTop {\n  width: 100%;\n}\n\n.cardTop {\n  padding: 1.5rem;\n  width: 100%;\n  padding-bottom: 0;\n  display: flex;\n}\n\n.leftWrap {\n  padding: 1.5rem;\n  padding-right: 0;\n  max-width: 50%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.container a {\n  text-decoration: underline;\n  font-style: italic;\n}\n\n.newsBottom p {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 28px;\n  color: var(--darkestGrey);\n}\n\n.newsBottom h2 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32px;\n  color: var(--illiniDarkBlue);\n}\n\n.newsBottom h3 {\n  font-family: \"Source Sans Pro\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 32px;\n  color: var(--illiniDarkBlue);\n}\n\n.newsBottom img {\n  padding: 1rem;\n  height: auto;\n  max-width: 100%;\n  float: right;\n}\nol {\n  list-style: none;\n  color: var(--darkestGrey);\n  width: 100%;\n}\n\n.results {\n  list-style: none;\n}\n\n.categoryIcon {\n  width: 2rem;\n  margin-right: 1rem;\n  height: 2rem;\n  margin-bottom: 0px;\n  margin-top: 0px;\n}\n\n.secondaryLabelMax {\n  font-family: Montserrat;\n  font-style: normal;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n}\n\n.selected {\n  background: var(--illiniDarkBlue);\n  color: white;\n}\n\n.selected:hover {\n  color: var(--illiniDarkBlue);\n  border: 2px solid var(--illiniDarkBlue);\n}\n\n.wp-block-file__button {\n  background: var(--illiniDarkBlue);\n  color: var(--white);\n  border-radius: 0.5rem;\n  padding: 0.5rem;\n  /* border: 1px solid var(--illiniOrange); */\n  margin-left: 1rem;\n  margin-right: 1rem;\n  line-height: 3rem;\n\n  text-decoration: none !important;\n  font-style: normal !important;\n}\n\n.wp-block-file > a:first-of-type {\n  text-decoration: underline;\n  font-style: italic;\n}\n\n.wp-block-gallery {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n}\n\n.wp-block-gallery > figure {\n  width: 30%;\n}\n\n@media only screen and (max-width: 992px) {\n  .col-sm-4 {\n    width: 50%;\n    float: left;\n    position: relative;\n    min-height: 1px;\n  }\n\n  .rightTop {\n    margin-top: 0rem;\n  }\n  .leftWrap {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .pageImage {\n    margin-bottom: 1rem;\n  }\n\n  .wp-block-gallery > figure {\n    width: 45%;\n  }\n\n  .container {\n    padding: 2rem;\n    justify-content: space-around;\n  }\n  .wp-block-group__inner-container {\n    width: 80vw;\n    max-width: 80vw;\n  }\n\n  .serviceTop {\n    text-align: center;\n    word-wrap: revert;\n    max-width: 100%;\n    justify-content: center;\n  }\n\n  .wp-block-ub-content-toggle {\n    width: 50%;\n  }\n\n  .test {\n  }\n}\n@media only screen and (max-width: 480px) {\n  .col-sm-4 {\n    width: 100%;\n    float: left;\n    position: relative;\n    min-height: 1px;\n  }\n  .leftWrap {\n    max-width: 100%;\n    width: 100%;\n  }\n\n  .wp-block-gallery > figure {\n    width: 100%;\n  }\n\n  .primaryTitle {\n    font-size: 2.5rem;\n    line-height: 2.5rem;\n  }\n  html {\n    font-size: 100%;\n  }\n\n  .wp-block-ub-content-toggle {\n    width: 100%;\n  }\n  .wp-block-group__inner-container {\n    width: 80vw;\n    max-width: 80vw;\n  }\n\n  .container {\n    width: 100%;\n    padding: 1rem;\n  }\n\n  .serviceTop {\n    text-align: center;\n    word-wrap: revert;\n    max-width: 100%;\n    justify-content: center;\n  }\n\n  .contactCardHolder {\n    width: 300px;\n    margin: 0 auto;\n    display: block;\n  }\n}\n\n.wp-block-ub-content-toggle-accordion {\n}\n\n.nope {\n  color: rgba(0, 0, 0, 0);\n}\n\n.ub-advanced-video-container {\n  width: fit-content;\n  max-width: 100%;\n}\n\n.ub-advanced-video-thumbnail {\n  position: relative;\n}\n\n.ub-advanced-video-thumbnail > svg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-youtube {\n  width: 100%;\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-youtube > iframe {\n  width: 100%;\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo,\n.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {\n  position: relative;\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-vimeo > iframe,\n.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion > iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion {\n  height: 0;\n  overflow: hidden;\n}\n\n.ub-advanced-video-embed.ub-advanced-video-autofit-dailymotion > iframe {\n  overflow: hidden;\n}\n\n.wp-block-ub-button-block {\n  margin: 30px auto;\n  max-width: 100%;\n}\n\n.ub-button-container {\n  max-width: 100%;\n  display: flex;\n  padding: 10px 0;\n  margin: 20px 0;\n}\n\n.ub-button-container a.ub-button-block-main.ub-button-block-main,\n.ub-button-container a.ub-button-block-btn.ub-button-block-btn {\n  text-decoration: none;\n}\n\n.ub-button-full-container {\n  width: 100%;\n}\n\n.ub-button-block-main {\n  display: flex;\n  cursor: pointer;\n  transition: background-color 0.5s, color 0.5s, border 0.5s;\n}\n\n.align-button-center {\n  justify-content: center;\n}\n\n.align-button-left {\n  justify-content: flex-start;\n}\n\n.align-button-right {\n  justify-content: flex-end;\n}\n\n.ub-button-small {\n  width: 180px;\n  padding: 10px;\n  font-size: 13px !important;\n}\n\n.ub-button-medium {\n  width: 275px;\n  padding: 15px;\n  font-size: 17px !important;\n}\n\n.ub-button-large {\n  width: 417px;\n  padding: 20px;\n  font-size: 22px !important;\n}\n\n.ub-button-larger {\n  width: 512px;\n  padding: 20px;\n  font-size: 25px !important;\n}\n\n.ub-button-flex-small {\n  width: fit-content;\n  width: -moz-fit-content;\n}\n\n.ub-button-flex-medium {\n  width: fit-content;\n  width: -moz-fit-content;\n}\n\n.ub-button-flex-large {\n  width: fit-content;\n  width: -moz-fit-content;\n}\n\n.ub-button-flex-larger {\n  width: fit-content;\n  width: -moz-fit-content;\n}\n\n.ub-button-block-btn {\n  text-align: center;\n  color: inherit;\n  margin: 0 10px;\n  display: flex;\n  align-items: center;\n}\n\n.ub-button-content-holder {\n  display: flex;\n  margin: 0 auto;\n}\n\n.ub-button-icon-holder {\n  display: flex;\n  align-items: center;\n  padding: 0 2px;\n}\n\n.ub-button-full-width {\n  width: 100%;\n}\n\n.ub-buttons {\n  margin: 20px 0;\n}\n\n.ub-buttons.align-button-center {\n  text-align: center;\n}\n\n.ub-buttons.align-button-left {\n  text-align: left;\n}\n\n.ub-buttons.align-button-right {\n  text-align: right;\n}\n\n.ub-buttons > .ub-button-container {\n  display: inline-block;\n  margin: 0 10px;\n}\n\n@media (max-width: 599px) {\n  .ub-button-flex-small {\n    min-width: 70%;\n  }\n  .ub-button-flex-medium {\n    min-width: 80%;\n  }\n  .ub-button-flex-large {\n    min-width: 90%;\n  }\n  .ub-button-flex-larger {\n    min-width: 100%;\n  }\n}\n\n.wp-block-ub-block-call-to-action {\n  margin: 0 auto;\n  max-width: 100%;\n}\n\n.ub_call_to_action {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 60px;\n  margin: 30px 0 60px 0;\n  border-style: solid;\n  border-radius: 3px;\n}\n\n.ub_call_to_action .ub_call_to_action_button {\n  display: flex;\n  align-items: center;\n}\n\n.ub_call_to_action .ub_call_to_action_button .ub_cta_button a,\n.ub_call_to_action .ub_call_to_action_button a.ub_cta_button {\n  text-decoration: none;\n}\n\n.ub_call_to_action_headline {\n  width: 100%;\n  padding: 20px 20px 10px 20px;\n}\n\n.ub_call_to_action_headline p,\n.ub_call_to_action_headline h2 {\n  text-align: center;\n  margin: 0;\n  padding: 20px 20px 0 20px;\n}\n\n.ub_call_to_action_content {\n  width: 100%;\n  padding: 0 0 15px 0;\n}\n\n.ub_call_to_action_content p {\n  text-align: justify;\n}\n\n.ub_cta_button {\n  margin-bottom: -31px !important;\n  padding: 20px !important;\n  position: relative;\n  box-sizing: border-box;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 3px;\n}\n\n.ub_cta_button_text {\n  margin: 0 !important;\n  text-align: center;\n}\n\n@media (max-width: 1199.98px) {\n  .ub_call_to_action {\n    padding: 0 30px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .ub_call_to_action {\n    padding: 0 20px;\n    margin-bottom: 60px !important;\n  }\n  .ub_call_to_action_headline {\n    padding: 20px 0 0 0;\n  }\n  .ub_call_to_action_headline p {\n    line-height: 1.3;\n    padding: 20px 0;\n  }\n}\n\n@media (max-width: 320px) {\n  .ub_call_to_action_button .ub_cta_button_text {\n    font-size: 14px !important;\n    font-weight: 600;\n  }\n  .ub_call_to_action {\n    padding: 0 10px;\n  }\n}\n\n.wp-block-ub-block-click-to-tweet {\n  margin: 0 auto;\n  max-width: 100%;\n}\n\n.ub_click_to_tweet {\n  width: 95%;\n  border: 1px solid;\n  border-radius: 4px;\n  padding: 10px;\n  margin: 25px 0px;\n}\n\n.ub_tweet {\n  padding: 10px;\n  margin-left: 10px;\n  font-family: \"Segoe UI\", Arial, sans-serif;\n}\n\n.ub_click_tweet {\n  text-align: right;\n  padding: 10px;\n  margin-right: 10px;\n}\n\n.ub_click_tweet > span {\n  display: inline-block;\n}\n\n.ub_click_tweet i {\n  display: inline-block;\n  width: 16px;\n  height: 14px;\n  background-position-x: 0%;\n  background-position-y: 0%;\n  margin-right: 3px;\n  position: relative;\n  top: 0;\n  background-position: 0 -151px;\n  width: 25px;\n  height: 20px;\n}\n\n@media (max-width: 479.98px) {\n  .ub_click_tweet {\n    width: 100%;\n    float: none;\n    padding: 0;\n    margin: 10px 0 !important;\n  }\n  .ub_tweet {\n    padding: 0;\n    margin-left: 0;\n    line-height: 1.5;\n  }\n}\n\n.ub-hide {\n  display: none;\n}\n\n.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ub-toggle-transition {\n  transition: all 0.5s ease-in-out;\n}\n\n.ub-icon-holder {\n  position: relative;\n  transform: translate(-25%, 25%);\n}\n\n.ub-custom-id-input {\n  font-size: 0.9em;\n}\n\n@media (max-width: 699px) {\n  .ub-mobile-hide {\n    display: none;\n  }\n  .ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tablet-hide {\n    display: none;\n  }\n  .ub-tablet-display {\n    display: block;\n  }\n}\n\n.ub-content-filter-tag {\n  display: inline-block;\n  min-height: 32px;\n  min-width: 100px;\n  margin: 5px 10px 5px 0;\n  padding: 8px;\n  border-radius: 3px;\n  text-align: center;\n}\n\n.ub-content-filter-category-name {\n  font-size: 1.625em;\n  font-weight: 800;\n  margin-bottom: 15px;\n}\n\n.ub-content-filter-category {\n  margin-bottom: 10px;\n  padding: 3px;\n}\n\n.ub-content-filter-tag {\n  cursor: pointer;\n}\n\n.ub-hide {\n  display: none;\n}\n\n.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ub-toggle-transition {\n  transition: all 0.5s ease-in-out;\n}\n\n.ub-icon-holder {\n  position: relative;\n  transform: translate(-25%, 25%);\n}\n\n.ub-custom-id-input {\n  font-size: 0.9em;\n}\n\n@media (max-width: 699px) {\n  .ub-mobile-hide {\n    display: none;\n  }\n  .ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tablet-hide {\n    display: none;\n  }\n  .ub-tablet-display {\n    display: block;\n  }\n}\n\n.wp-block-ub-content-toggle {\n  margin: 20px 0 20px 0;\n  max-width: 100%;\n  width: 100%;\n}\n\n.wp-block-ub-content-toggle-accordion {\n  position: relative;\n\n  margin-bottom: 10px;\n}\n\n.wp-block-ub-content-toggle-accordion.no-border {\n  border: 0 !important;\n}\n\n.wp-block-ub-content-toggle-accordion\n  .wp-block-ub-content-toggle-accordion-title {\n  padding: 10px 10px 10px 25px;\n  margin: 0;\n  display: block;\n}\n\n.wp-block-ub-content-toggle-accordion-content {\n  padding: 25px;\n}\n\n.wp-block-ub-content-toggle-accordion-controls-top {\n  position: absolute;\n  top: -10px;\n  left: 0;\n  right: 0;\n  justify-content: center;\n  display: flex;\n  opacity: 0;\n  transition: 0.5s opacity ease-in-out;\n}\n\n.wp-block-ub-content-toggle-accordion-controls-top > span {\n  display: inline-block;\n  margin: 0 3px;\n}\n\n.wp-block-ub-content-toggle-accordion-controls-bottom {\n  position: absolute;\n  bottom: -10px;\n  left: 0;\n  right: 0;\n  justify-content: center;\n  display: flex;\n  opacity: 0;\n  transition: 0.5s opacity ease-in-out;\n}\n\n.wp-block-ub-content-toggle-accordion-controls-bottom > span {\n  display: inline-block;\n  margin: 0 3px;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap {\n  display: flex;\n  align-items: center;\n  background: var(--illiniDarkBlue);\n  color: var(--white);\n  cursor: pointer;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap > *:first-child {\n  flex-grow: 1;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-toggle-wrap {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-toggle-wrap.left {\n  order: -1;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-toggle-wrap.right {\n  order: 0;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-toggle-wrap\n  .wp-block-ub-content-toggle-accordion-toggle-location {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 150%;\n  opacity: 0;\n  transition: 0.5s opacity ease-in-out;\n  text-align: center;\n  color: #191e23;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-state-indicator {\n  display: block;\n  margin: 0 10px;\n  transition: 0.5s all;\n  transform: rotate(0deg);\n  color: inherit;\n}\n\n.wp-block-ub-content-toggle-accordion-title-wrap\n  .wp-block-ub-content-toggle-accordion-state-indicator.open {\n  transform: rotate(90deg);\n}\n\n.wp-block-ub-content-toggle-accordion-content-wrap {\n  box-sizing: border-box;\n  padding: 13px 4%;\n  overflow: hidden;\n}\n\n.wp-block-ub-content-toggle-accordion-content-wrap.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.wp-block-ub-content-toggle-accordion:hover\n  .wp-block-ub-content-toggle-accordion-controls-top,\n.wp-block-ub-content-toggle-accordion:hover\n  .wp-block-ub-content-toggle-accordion-controls-bottom,\n.wp-block-ub-content-toggle-accordion:hover\n  .wp-block-ub-content-toggle-accordion-toggle-location {\n  opacity: 1 !important;\n}\n\n@media (max-width: 479.98px) {\n  .wp-block-ub-content-toggle-accordion\n    .wp-block-ub-content-toggle-accordion-title {\n    padding: 10px;\n  }\n}\n\n@media (max-width: 374.98px) {\n  .wp-block-ub-content-toggle-accordion\n    .wp-block-ub-content-toggle-accordion-title {\n    padding: 10px 0 10px 10px;\n  }\n  .wp-block-ub-content-toggle-accordion-content-wrap p {\n    margin: 15px 0 10px;\n  }\n}\n\n.wp-block-ub-chevron-down {\n  box-sizing: border-box;\n  position: relative;\n  display: block;\n  transform: scale(var(--ggs, 1));\n  width: 22px;\n  height: 22px;\n  border: 2px solid rgba(0, 0, 0, 0);\n  border-radius: 100px;\n}\n\n.wp-block-ub-chevron-down::after {\n  content: \"\";\n  display: block;\n  box-sizing: border-box;\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-bottom: 2px solid;\n  border-right: 2px solid;\n  transform: rotate(-45deg);\n  left: 4px;\n  top: 2px;\n}\n\n.wp-block-ub-math-plus,\n.wp-block-ub-math-plus::after {\n  display: block;\n  box-sizing: border-box;\n  background: currentColor;\n  border-radius: 10px;\n}\n\n.wp-block-ub-math-plus {\n  margin-top: -2px;\n  position: relative;\n  transform: scale(var(--ggs, 1));\n  width: 16px;\n  height: 2px;\n}\n\n.wp-block-ub-math-plus.open {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.wp-block-ub-math-plus::after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 16px;\n  top: -7px;\n  left: 7px;\n}\n\n.wp-block-ub-math-plus + .wp-block-ub-content-toggle-accordion-toggle-location {\n  margin-top: 60px;\n}\n\n.ub_countdown_circular_container {\n  display: grid;\n}\n\n.ub_countdown_circular_container p {\n  text-align: center;\n}\n\n.ub_countdown_circular_container > div {\n  margin: 0 auto;\n}\n\n.ub_countdown_circular_container > div svg {\n  position: absolute;\n}\n\n.ub_countdown_circle_path {\n  stroke-linecap: round;\n  stroke-dashoffset: 0px;\n  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,\n    stroke 0.3s ease 0s, stroke-width 0.06s ease 0.3s;\n  fill-opacity: 0;\n}\n\n.ub_countdown_circle_label {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  text-align: center;\n}\n\n.ub-countdown-separator {\n  margin: 0 auto;\n  font-size: 35px;\n}\n\n.ub-countdown-odometer-container {\n  display: grid;\n}\n\n.ub-countdown-odometer-container span {\n  text-align: center;\n}\n\n.ub-countdown-digit-container {\n  height: 1.5em;\n  overflow-y: hidden;\n  margin: 0 auto;\n  font-size: 35px;\n}\n\n.ub-countdown-digit-container > .digit,\n.ub-countdown-digit-container > .moving-digit {\n  float: left;\n}\n\n.ub-countdown-odometer {\n  margin: 0 auto;\n  font-size: 35px;\n}\n\n.ub-countdown-odometer-digit,\n.ub-countdown-odometer-digits {\n  float: left;\n}\n\n.ub_countdown_style_selector {\n  display: flex;\n  flex-direction: row;\n}\n\n.ub-countdown {\n  margin-bottom: 20px;\n}\n\n.ub-countdown > div {\n  text-align: initial;\n}\n\n@media (max-width: 991.98px) {\n  .ub-countdown .ub_countdown_week,\n  .ub-countdown .ub_countdown_day,\n  .ub-countdown .ub_countdown_hour,\n  .ub-countdown .ub_countdown_minute,\n  .ub-countdown .ub_countdown_second,\n  .ub-countdown-odometer-container span {\n    font-size: 14px !important;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .ub-countdown .ub_countdown_week,\n  .ub-countdown .ub_countdown_day,\n  .ub-countdown .ub_countdown_hour,\n  .ub-countdown .ub_countdown_minute,\n  .ub-countdown .ub_countdown_second {\n    margin: 0 1px;\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 479.98px) {\n  .ub-countdown-separator,\n  .ub-countdown-odometer {\n    font-size: 20px;\n  }\n  .ub-countdown {\n    margin-bottom: 20px;\n    font-size: 14px;\n    display: inline-flex;\n  }\n  .ub-countdown .ub_countdown_week,\n  .ub-countdown .ub_countdown_day,\n  .ub-countdown .ub_countdown_hour,\n  .ub-countdown .ub_countdown_minute,\n  .ub-countdown .ub_countdown_second {\n    font-size: 14px !important;\n  }\n  .ub_countdown_circular_container > div {\n    height: 60px;\n    width: 60px;\n  }\n  .ub_countdown_circular_container > div svg {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n@media (max-width: 374.98px) {\n  .ub_countdown_circular_container div {\n    height: 50px;\n    width: 50px;\n  }\n  .ub_countdown_circular_container > div svg {\n    width: 50px;\n    height: 50px;\n  }\n  .ub-countdown .ub_countdown_week,\n  .ub-countdown .ub_countdown_day,\n  .ub-countdown .ub_countdown_hour,\n  .ub-countdown .ub_countdown_minute,\n  .ub-countdown .ub_countdown_second,\n  .ub-countdown-odometer-container span,\n  .ub-countdown {\n    font-size: 10px !important;\n  }\n}\n\n@media (max-width: 320px) {\n  .ub-countdown,\n  .ub-countdown-separator,\n  .ub-countdown-odometer {\n    font-size: 10px;\n  }\n  .ub_countdown_circular_container > div {\n    height: 40px;\n    width: 40px;\n  }\n  .ub_countdown_circular_container > div svg {\n    width: 40px;\n    height: 40px;\n  }\n  .ub-countdown .ub_countdown_week,\n  .ub-countdown .ub_countdown_day,\n  .ub-countdown .ub_countdown_hour,\n  .ub-countdown .ub_countdown_minute,\n  .ub-countdown .ub_countdown_second {\n    margin: 0;\n    font-size: 10px !important;\n  }\n}\n\n.ub_divider {\n  display: flex;\n  margin-left: auto;\n  margin-right: auto;\n  align-content: center;\n  border-bottom: none;\n}\n\n.ub_divider.ub_divider:not(.alignwide):not(.alignfull):not(.alignleft):not(\n    .alignright\n  ):not(.wp-block-separator):not(.woocommerce) {\n  max-width: initial;\n}\n\n.entry-content.entry-content .ub_divider {\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.entry-content.entry-content .ub_divider::before,\n.entry-content.entry-content .ub_divider::after {\n  content: none;\n}\n\n.ub-expand {\n  padding-bottom: 1em;\n}\n\n.ub-expand-toggle-button {\n  display: block;\n  cursor: pointer;\n}\n\n.ub-hide {\n  display: none;\n}\n\n.wp-block-ub-feature-box {\n  margin: 20px 0 20px 0;\n  max-width: 100%;\n}\n\n.ub_feature_box {\n  display: flex;\n  margin: 1rem 0;\n}\n\n.ub_feature_box > div {\n  text-align: justify;\n  margin: 0 auto;\n}\n\n.ub_feature_box.column_1 .ub_feature_2,\n.ub_feature_box.column_1 .ub_feature_3 {\n  display: none;\n}\n\n.ub_feature_box.column_1 > div {\n  width: 100%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  padding: 1rem;\n}\n\n.ub_feature_box.column_2 .ub_feature_3 {\n  display: none;\n}\n\n.ub_feature_box.column_2 > div {\n  width: 49%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  padding: 1rem;\n}\n\n.ub_feature_box.column_3 > div {\n  width: 33.2%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  padding: 1rem;\n}\n\n.ub_feature_box.column_3 > div:first-child {\n  margin-left: 0;\n}\n\n.ub_feature_box.column_3 > div:last-child {\n  margin-right: 0;\n}\n\n.ub_feature_box_feature {\n  border-radius: 100px;\n  overflow: hidden;\n  border: medium none;\n  max-width: 80px;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  margin-top: -60px !important;\n  margin-bottom: 25px;\n}\n\n.ub_feature_one_feature,\n.ub_feature_two_feature,\n.ub_feature_three_feature {\n  font-size: 40px !important;\n  text-align: center;\n  line-height: 80px !important;\n  margin: 0 auto !important;\n}\n\n.ub_feature_one_title,\n.ub_feature_two_title,\n.ub_feature_three_title {\n  font-size: 30px !important;\n  text-align: center;\n  margin: 20px 0 !important;\n  padding: 0;\n}\n\n.ub_feature_1 > img,\n.ub_feature_2 > img,\n.ub_feature_3 > img {\n  display: flex;\n  align-items: center;\n  margin-right: auto;\n  margin-left: auto;\n  max-width: 100%;\n}\n\n@media screen and (max-width: 800px) {\n  .ub_feature_box.column_3 {\n    display: block;\n  }\n  .ub_feature_box.column_3 > div {\n    width: 90% !important;\n    margin: 0 !important;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .ub_feature_box.column_2 {\n    display: block;\n  }\n  .ub_feature_box.column_2 > div {\n    width: 90% !important;\n    margin: 0 !important;\n  }\n}\n\n.ub_howto-step-image,\n.ub_howto-yield-image {\n  width: 100%;\n}\n\n.ub_howto-supplies-list img,\n.ub_howto-tools-list img {\n  max-width: 200px;\n}\n\n.ub_howto-section-display {\n  margin-left: 1em;\n}\n\n.ub_howto figcaption {\n  margin-top: 5px;\n  text-align: center;\n}\n\n.ub_howto-step-display .ub_howto-step {\n  list-style-position: outside;\n}\n\n.ub_howto-step {\n  overflow: auto;\n}\n\n.ub_howto-step > figure,\n.ub_howto-step > img {\n  margin-bottom: 10px;\n}\n\n.ub_howto-yield {\n  overflow: auto;\n}\n\n@media screen and (max-width: 767px) {\n  .ub_howto .ub_howto-steps-list .ub_howto-step > figure,\n  .ub_howto .ub_howto-section .ub_howto-steps-list .ub_howto-step > figure,\n  .ub_howto .ub_howto-step-display .ub_howto-step > figure,\n  .ub_howto .ub_howto-section .ub_howto-step-display .ub_howto-step > figure {\n    width: 100%;\n    float: none;\n  }\n}\n\n.ub_image_slider {\n  margin-bottom: 30px;\n}\n\n.ub_image_slider .ub_image_slider_image_caption {\n  display: block;\n  text-align: center;\n}\n\n.ub_image_slider .ub_image_slider_alt {\n  font-size: 0.8em;\n}\n\n.ub_image_slider .swiper-slide > img,\n.ub_image_slider .swiper-slide > picture > img,\n.ub_image_slider .swiper-slide figure > img,\n.ub_image_slider .swiper-slide figure > picture > img {\n  display: block;\n  margin: auto;\n}\n\n@font-face {\n  font-family: \"swiper-icons\";\n  src: url(\"data:application/font-woff;charset=utf-8;base64, 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\")\n    format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n:root {\n  --swiper-theme-color: #007aff;\n}\n\n.swiper-container {\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  overflow: hidden;\n  list-style: none;\n  padding: 0;\n  z-index: 1;\n}\n\n.swiper-container-vertical > .swiper-wrapper {\n  flex-direction: column;\n}\n\n.swiper-wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  display: flex;\n  transition-property: transform;\n  box-sizing: content-box;\n}\n\n.swiper-container-android .swiper-slide,\n.swiper-wrapper {\n  transform: translate3d(0px, 0, 0);\n}\n\n.swiper-container-multirow > .swiper-wrapper {\n  flex-wrap: wrap;\n}\n\n.swiper-container-multirow-column > .swiper-wrapper {\n  flex-wrap: wrap;\n  flex-direction: column;\n}\n\n.swiper-container-free-mode > .swiper-wrapper {\n  transition-timing-function: ease-out;\n  margin: 0 auto;\n}\n\n.swiper-container-pointer-events {\n  touch-action: pan-y;\n}\n\n.swiper-container-pointer-events.swiper-container-vertical {\n  touch-action: pan-x;\n}\n\n.swiper-slide {\n  flex-shrink: 0;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  transition-property: transform;\n}\n\n.swiper-slide-invisible-blank {\n  visibility: hidden;\n}\n\n.swiper-container-autoheight,\n.swiper-container-autoheight .swiper-slide {\n  height: auto;\n}\n\n.swiper-container-autoheight .swiper-wrapper {\n  align-items: flex-start;\n  transition-property: transform, height;\n}\n\n.swiper-container-3d {\n  perspective: 1200px;\n}\n\n.swiper-container-3d .swiper-wrapper,\n.swiper-container-3d .swiper-slide,\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom,\n.swiper-container-3d .swiper-cube-shadow {\n  transform-style: preserve-3d;\n}\n\n.swiper-container-3d .swiper-slide-shadow-left,\n.swiper-container-3d .swiper-slide-shadow-right,\n.swiper-container-3d .swiper-slide-shadow-top,\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.swiper-container-3d .swiper-slide-shadow-left {\n  background-image: linear-gradient(\n    to left,\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.swiper-container-3d .swiper-slide-shadow-right {\n  background-image: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.swiper-container-3d .swiper-slide-shadow-top {\n  background-image: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.swiper-container-3d .swiper-slide-shadow-bottom {\n  background-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.5),\n    rgba(0, 0, 0, 0)\n  );\n}\n\n.swiper-container-css-mode > .swiper-wrapper {\n  overflow: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.swiper-container-css-mode > .swiper-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.swiper-container-css-mode > .swiper-wrapper > .swiper-slide {\n  scroll-snap-align: start start;\n}\n\n.swiper-container-horizontal.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: x mandatory;\n}\n\n.swiper-container-vertical.swiper-container-css-mode > .swiper-wrapper {\n  scroll-snap-type: y mandatory;\n}\n\n:root {\n  --swiper-navigation-size: 44px;\n}\n\n.swiper-button-prev,\n.swiper-button-next {\n  position: absolute;\n  top: 50%;\n  width: calc(var(--swiper-navigation-size) / 44 * 27);\n  height: var(--swiper-navigation-size);\n  margin-top: calc(0px - var(--swiper-navigation-size) / 2);\n  z-index: 10;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--swiper-navigation-color, var(--swiper-theme-color));\n}\n\n.swiper-button-prev.swiper-button-disabled,\n.swiper-button-next.swiper-button-disabled {\n  opacity: 0.35;\n  cursor: auto;\n  pointer-events: none;\n}\n\n.swiper-button-prev:after,\n.swiper-button-next:after {\n  font-family: swiper-icons;\n  font-size: var(--swiper-navigation-size);\n  text-transform: none !important;\n  letter-spacing: 0;\n  text-transform: none;\n  font-variant: initial;\n  line-height: 1;\n}\n\n.swiper-button-prev,\n.swiper-container-rtl .swiper-button-next {\n  left: 10px;\n  right: auto;\n}\n\n.swiper-button-prev:after,\n.swiper-container-rtl .swiper-button-next:after {\n  content: \"prev\";\n}\n\n.swiper-button-next,\n.swiper-container-rtl .swiper-button-prev {\n  right: 10px;\n  left: auto;\n}\n\n.swiper-button-next:after,\n.swiper-container-rtl .swiper-button-prev:after {\n  content: \"next\";\n}\n\n.swiper-button-prev.swiper-button-white,\n.swiper-button-next.swiper-button-white {\n  --swiper-navigation-color: #ffffff;\n}\n\n.swiper-button-prev.swiper-button-black,\n.swiper-button-next.swiper-button-black {\n  --swiper-navigation-color: #000000;\n}\n\n.swiper-button-lock {\n  display: none;\n}\n\n.swiper-pagination {\n  position: absolute;\n  text-align: center;\n  transition: 300ms opacity;\n  transform: translate3d(0, 0, 0);\n  z-index: 10;\n}\n\n.swiper-pagination.swiper-pagination-hidden {\n  opacity: 0;\n}\n\n.swiper-pagination-fraction,\n.swiper-pagination-custom,\n.swiper-container-horizontal > .swiper-pagination-bullets {\n  bottom: 10px;\n  left: 0;\n  width: 100%;\n}\n\n.swiper-pagination-bullets-dynamic {\n  overflow: hidden;\n  font-size: 0;\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {\n  transform: scale(0.33);\n  position: relative;\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {\n  transform: scale(1);\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {\n  transform: scale(1);\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {\n  transform: scale(0.66);\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {\n  transform: scale(0.33);\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {\n  transform: scale(0.66);\n}\n\n.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {\n  transform: scale(0.33);\n}\n\n.swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  display: inline-block;\n  border-radius: 50%;\n  background: #000;\n  opacity: 0.2;\n}\n\nbutton.swiper-pagination-bullet {\n  border: none;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  appearance: none;\n}\n\n.swiper-pagination-clickable .swiper-pagination-bullet {\n  cursor: pointer;\n}\n\n.swiper-pagination-bullet:only-child {\n  display: none !important;\n}\n\n.swiper-pagination-bullet-active {\n  opacity: 1;\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n}\n\n.swiper-container-vertical > .swiper-pagination-bullets {\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0px, -50%, 0);\n}\n\n.swiper-container-vertical\n  > .swiper-pagination-bullets\n  .swiper-pagination-bullet {\n  margin: 6px 0;\n  display: block;\n}\n\n.swiper-container-vertical\n  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  top: 50%;\n  transform: translateY(-50%);\n  width: 8px;\n}\n\n.swiper-container-vertical\n  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic\n  .swiper-pagination-bullet {\n  display: inline-block;\n  transition: 200ms transform, 200ms top;\n}\n\n.swiper-container-horizontal\n  > .swiper-pagination-bullets\n  .swiper-pagination-bullet {\n  margin: 0 4px;\n}\n\n.swiper-container-horizontal\n  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n\n.swiper-container-horizontal\n  > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic\n  .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms left;\n}\n\n.swiper-container-horizontal.swiper-container-rtl\n  > .swiper-pagination-bullets-dynamic\n  .swiper-pagination-bullet {\n  transition: 200ms transform, 200ms right;\n}\n\n.swiper-pagination-progressbar {\n  background: rgba(0, 0, 0, 0.25);\n  position: absolute;\n}\n\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: var(--swiper-pagination-color, var(--swiper-theme-color));\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  transform: scale(0);\n  transform-origin: left top;\n}\n\n.swiper-container-rtl\n  .swiper-pagination-progressbar\n  .swiper-pagination-progressbar-fill {\n  transform-origin: right top;\n}\n\n.swiper-container-horizontal > .swiper-pagination-progressbar,\n.swiper-container-vertical\n  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 100%;\n  height: 4px;\n  left: 0;\n  top: 0;\n}\n\n.swiper-container-vertical > .swiper-pagination-progressbar,\n.swiper-container-horizontal\n  > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {\n  width: 4px;\n  height: 100%;\n  left: 0;\n  top: 0;\n}\n\n.swiper-pagination-white {\n  --swiper-pagination-color: #ffffff;\n}\n\n.swiper-pagination-black {\n  --swiper-pagination-color: #000000;\n}\n\n.swiper-pagination-lock {\n  display: none;\n}\n\n.swiper-container-cube {\n  overflow: visible;\n}\n\n.swiper-container-cube .swiper-slide {\n  pointer-events: none;\n  backface-visibility: hidden;\n  z-index: 1;\n  visibility: hidden;\n  transform-origin: 0 0;\n  width: 100%;\n  height: 100%;\n}\n\n.swiper-container-cube .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n\n.swiper-container-cube.swiper-container-rtl .swiper-slide {\n  transform-origin: 100% 0;\n}\n\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n\n.swiper-container-cube .swiper-slide-active,\n.swiper-container-cube .swiper-slide-next,\n.swiper-container-cube .swiper-slide-prev,\n.swiper-container-cube .swiper-slide-next + .swiper-slide {\n  pointer-events: auto;\n  visibility: visible;\n}\n\n.swiper-container-cube .swiper-slide-shadow-top,\n.swiper-container-cube .swiper-slide-shadow-bottom,\n.swiper-container-cube .swiper-slide-shadow-left,\n.swiper-container-cube .swiper-slide-shadow-right {\n  z-index: 0;\n  backface-visibility: hidden;\n}\n\n.swiper-container-cube .swiper-cube-shadow {\n  position: absolute;\n  left: 0;\n  bottom: 0px;\n  width: 100%;\n  height: 100%;\n  opacity: 0.6;\n  z-index: 0;\n}\n\n.swiper-container-cube .swiper-cube-shadow:before {\n  content: \"\";\n  background: #000;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  -webkit-filter: blur(50px);\n  filter: blur(50px);\n}\n\n.swiper-container-fade.swiper-container-free-mode .swiper-slide {\n  transition-timing-function: ease-out;\n}\n\n.swiper-container-fade .swiper-slide {\n  pointer-events: none;\n  transition-property: opacity;\n}\n\n.swiper-container-fade .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n\n.swiper-container-fade .swiper-slide-active,\n.swiper-container-fade .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n\n.swiper-container-flip {\n  overflow: visible;\n}\n\n.swiper-container-flip .swiper-slide {\n  pointer-events: none;\n  backface-visibility: hidden;\n  z-index: 1;\n}\n\n.swiper-container-flip .swiper-slide .swiper-slide {\n  pointer-events: none;\n}\n\n.swiper-container-flip .swiper-slide-active,\n.swiper-container-flip .swiper-slide-active .swiper-slide-active {\n  pointer-events: auto;\n}\n\n.swiper-container-flip .swiper-slide-shadow-top,\n.swiper-container-flip .swiper-slide-shadow-bottom,\n.swiper-container-flip .swiper-slide-shadow-left,\n.swiper-container-flip .swiper-slide-shadow-right {\n  z-index: 0;\n  backface-visibility: hidden;\n}\n\n.ub_notify_info,\n.ub_notify_success,\n.ub_notify_warning {\n  margin: 10px 0px;\n  padding: 15px;\n  border-left-width: 4px;\n  border-left-style: solid;\n}\n\n.ub_notify_info .ub_notify_text,\n.ub_notify_success .ub_notify_text,\n.ub_notify_warning .ub_notify_text {\n  margin: 0 auto;\n}\n\n.ub_notify_info {\n  color: #31708f;\n  background-color: #d9edf7;\n  border-left-color: #31708f;\n}\n\n.ub_notify_success {\n  color: #3c763d;\n  background-color: #dff0d8;\n  border-left-color: #3c763d;\n}\n\n.ub_notify_warning {\n  color: #d8000c;\n  background-color: #ffd2d2;\n  border-left-color: #d8000c;\n}\n\n.wp-block-ub-number-box {\n  margin: 50px 0 50px 0;\n  max-width: 100%;\n}\n\n.ub_number_box {\n  display: flex;\n  margin: 1rem 0;\n  margin-top: 5rem;\n}\n\n.ub_number_box > div {\n  text-align: justify;\n  margin: 0 auto;\n}\n\n.ub_number_box.column_1 .ub_number_2,\n.ub_number_box.column_1 .ub_number_3 {\n  display: none;\n}\n\n.ub_number_box.column_1 > div {\n  width: 100%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  border: 1px solid;\n  padding: 1rem;\n}\n\n.ub_number_box.column_2 .ub_number_3 {\n  display: none;\n}\n\n.ub_number_box.column_2 > div {\n  width: 49%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  border: 1px solid;\n  padding: 1rem;\n}\n\n.ub_number_box.column_3 > div {\n  width: 33.2%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  border: 1px solid;\n  padding: 1rem;\n}\n\n.ub_number_box.column_3 > div:first-child {\n  margin-left: 0;\n}\n\n.ub_number_box.column_3 > div:last-child {\n  margin-right: 0;\n}\n\n.ub_number_box_number {\n  border-radius: 100px;\n  overflow: hidden;\n  border: medium none;\n  max-width: 80px;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  margin-top: -60px !important;\n  margin-bottom: 25px;\n}\n\n.ub_number_one_number,\n.ub_number_two_number,\n.ub_number_three_number {\n  font-size: 40px !important;\n  text-align: center;\n  line-height: 80px !important;\n  margin: 0 auto !important;\n}\n\n.ub_number_one_title,\n.ub_number_two_title,\n.ub_number_three_title {\n  font-size: 30px !important;\n  text-align: center;\n  margin: 10px auto;\n  padding: 0;\n}\n\n@media screen and (max-width: 800px) {\n  .ub_number_box.column_3 {\n    display: block;\n  }\n  .ub_number_box.column_3 > div {\n    width: 92% !important;\n    margin: 0 !important;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .ub_number_box.column_2 {\n    display: block;\n  }\n  .ub_number_box.column_2 > div {\n    width: 90% !important;\n    margin: 0 !important;\n  }\n}\n\n.ub-hide {\n  display: none;\n}\n\n.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ub-toggle-transition {\n  transition: all 0.5s ease-in-out;\n}\n\n.ub-icon-holder {\n  position: relative;\n  transform: translate(-25%, 25%);\n}\n\n.ub-custom-id-input {\n  font-size: 0.9em;\n}\n\n@media (max-width: 699px) {\n  .ub-mobile-hide {\n    display: none;\n  }\n  .ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tablet-hide {\n    display: none;\n  }\n  .ub-tablet-display {\n    display: block;\n  }\n}\n\n.ub-block-post-grid {\n  margin: 0 0 1.2em 0;\n  position: relative;\n}\n\n.ub-block-post-grid .is-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: 1fr;\n  grid-gap: 0 2em;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-grid {\n    display: block;\n  }\n}\n\n.ub-block-post-grid .is-grid article {\n  margin-bottom: 2.5em;\n  min-width: 0;\n  padding: 0;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-grid article {\n    padding-left: 10px;\n    padding-right: 10px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.ub-block-post-grid .is-grid.columns-1 {\n  grid-template-columns: 1fr;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-grid.columns-1 article {\n    width: 100%;\n  }\n}\n\n.ub-block-post-grid .is-grid.columns-2 {\n  grid-template-columns: 1fr 1fr;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-grid.columns-2 article {\n    width: 48%;\n  }\n}\n\n.ub-block-post-grid .is-grid.columns-3 {\n  grid-template-columns: 1fr 1fr 1fr;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-grid.columns-3 article {\n    width: 32%;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .ub-block-post-grid div[class*=\"columns\"].is-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ub-block-post-grid .ub_block-post-grid-text {\n  text-align: left;\n}\n\n.ub-block-post-grid a {\n  text-decoration: none;\n}\n\n.ub-block-post-grid .ub-block-post-grid-image {\n  margin-bottom: 1.2em;\n}\n\n.ub-block-post-grid .ub-block-post-grid-image img {\n  display: block;\n  width: 100%;\n}\n\n.ub-block-post-grid header .ub-block-post-grid-title {\n  margin-top: 0;\n  margin-bottom: 15px;\n  line-height: 1.2;\n}\n\n.ub-block-post-grid header .ub-block-post-grid-title a {\n  color: #292929;\n  text-decoration: none;\n}\n\n.ub-block-post-grid header .ub-block-post-grid-title a:hover {\n  text-decoration: underline;\n  color: inherit;\n}\n\n.ub-block-post-grid .ub-block-post-grid-author,\n.ub-block-post-grid .ub-block-post-grid-date {\n  display: inline-block;\n}\n\n.ub-block-post-grid .ub-block-post-grid-author:not(:last-child):after,\n.ub-block-post-grid .ub-block-post-grid-date:not(:last-child):after {\n  content: \"\";\n  vertical-align: middle;\n  margin: 0 5px;\n  line-height: 1;\n}\n\n.ub-block-post-grid .ub-block-post-grid-author a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.ub-block-post-grid .ub-block-post-grid-author a:hover {\n  color: inherit;\n  text-decoration: underline;\n}\n\n.ub-block-post-grid .ub-block-post-grid-more-link {\n  display: inline-block;\n  box-shadow: none;\n  transition: 0.3s ease;\n  font-weight: bold;\n  color: #292929;\n  text-decoration: none;\n}\n\n.ub-block-post-grid .ub-block-post-grid-more-link:hover {\n  text-decoration: underline;\n}\n\n.ub-block-post-grid .ub-block-post-grid-excerpt > p:last-child {\n  margin-top: 15px;\n  margin-bottom: 0;\n}\n\n.ub-block-post-grid .is-list article {\n  display: grid;\n  grid-template-columns: 30% 1fr;\n  grid-template-rows: 1fr;\n  grid-gap: 0 2em;\n  padding: 0;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-list article {\n    display: block;\n  }\n}\n\n.ub-block-post-grid .is-list article:before {\n  display: none;\n}\n\n.ub-block-post-grid .is-list article:not(:last-child) {\n  margin-bottom: 5%;\n  padding-bottom: 5%;\n}\n\n.ub-block-post-grid .is-list article:not(.has-post-thumbnail) {\n  grid-template-columns: 1fr;\n}\n\n@media only screen and (min-width: 600px) {\n  .ub-block-post-grid .is-list article:not(:last-child) {\n    border-bottom: solid 1px #eee;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .ub-block-post-grid .is-list article {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ub-block-post-grid .is-list .ub-block-post-grid-image {\n  margin-bottom: 0;\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-list .ub-block-post-grid-image {\n    width: 30%;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n@media only screen and (max-width: 600px) {\n  .ub-block-post-grid .is-list .ub-block-post-grid-image {\n    margin-bottom: 5%;\n  }\n}\n\n@media all and (-ms-high-contrast: none) {\n  .ub-block-post-grid .is-list .ub-block-post-grid-text {\n    width: 65%;\n    padding-left: 5%;\n    display: inline-block;\n    vertical-align: top;\n  }\n  .ub-block-post-grid\n    .is-list\n    .post:not(.has-post-thumbnail)\n    .ub-block-post-grid-text {\n    width: 100%;\n    padding-left: 0;\n  }\n}\n\n.ub-block-post-grid .is-list .no-thumb .ub-block-post-grid-text {\n  grid-column: span 2;\n}\n\n.ub-block-post-grid-image {\n  position: relative;\n}\n\n.ub-block-post-grid-image:hover .ub-post-grid-no-image-placeholder {\n  opacity: 1;\n  z-index: 1;\n}\n\n.ub-post-grid-no-image-placeholder {\n  padding: 40px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  background: #f3f3f4;\n  transition: 0.2s ease;\n}\n\n.ub-post-grid-no-image-placeholder svg {\n  margin-bottom: 10px;\n}\n\n.ub-post-grid-no-image-icon {\n  position: absolute;\n  top: 10px;\n  background: #ffe606;\n  right: 10px;\n  padding: 6px;\n  line-height: 1;\n  height: 32px;\n  transition: 0.2s ease;\n  border-radius: 5px;\n  z-index: 1;\n}\n\n.ub_progress-bar {\n  overflow: auto;\n}\n\n.ub_progress-bar-container {\n  text-align: start;\n}\n\n.ub_progress-bar-circle {\n  position: absolute;\n}\n\n.ub_progress-bar-circle + .ub_progress-bar-label {\n  position: relative;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: auto;\n  text-align: center;\n}\n\n.ub_progress-bar-circle-trail {\n  stroke-dashoffset: 0px;\n  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,\n    stroke 0.3s ease 0s;\n  fill-opacity: 0;\n}\n\n.ub_progress-bar-circle-path {\n  stroke-dashoffset: 0px;\n  transition: stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s,\n    stroke 0.3s ease 0s, stroke-width 0.06s ease 0.3s;\n  fill-opacity: 0;\n}\n\n.ub_progress-bar-line-trail {\n  fill-opacity: 0;\n  stroke-linecap: round;\n}\n\n.ub_progress-bar-line-path {\n  stroke-dasharray: 100px, 100px;\n  transition: stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear 0s;\n  fill-opacity: 0;\n  stroke-linecap: round;\n}\n\n.ub_progress-bar-line + .ub_progress-bar-label {\n  text-align: right;\n  min-width: 24px;\n}\n\n.ub_review_block {\n  padding: 35px 40px;\n  box-shadow: 0px 0px 4px 1px #d6d6d6;\n  border-radius: 5px;\n  margin: 30px auto;\n}\n\n.ub_review_block svg:not(:root) {\n  margin: 0 1px;\n}\n\n.ub_review_block svg:not(:root):first-child {\n  margin-left: 0;\n}\n\n.ub_review_block svg:not(:root):last-child {\n  margin-right: 0;\n}\n\n.ub_review_block .ub_review_image {\n  margin-top: 10px;\n  float: right;\n  object-fit: contain;\n}\n\n.ub_review_overall_value {\n  display: grid;\n  grid-template-columns: 75% 25%;\n}\n\n.ub_review_entry,\n.ub_review_percentage_entry {\n  padding: 10px 0 10px 0;\n  border-bottom: 1px solid #e9e9e9;\n}\n\n.ub_review_entry {\n  display: flex;\n}\n\n.ub_review_percentage_entry {\n  display: grid;\n  grid-template-columns: 25% 75%;\n}\n\n.ub_review_rating {\n  text-align: right;\n  font-size: 40px;\n}\n\n.ub_review_average {\n  display: flex;\n  flex-direction: column;\n}\n\n.ub_review_average_stars {\n  display: flex;\n  grid-area: auto;\n  justify-self: self-end;\n  height: 50px;\n  line-height: 60px;\n  margin-left: auto;\n  align-items: center;\n}\n\n.ub_review_cta_panel {\n  display: grid;\n  grid-template-columns: 2fr auto;\n  grid-template-areas: \"cta . stars\";\n}\n\n.ub_review_add_entry {\n  left: 50%;\n  width: 100%;\n}\n\n.ub_review_link_input {\n  display: flex;\n  flex-direction: row;\n}\n\n.ub_review_cta_btn {\n  min-width: 100px;\n  padding: 15px 10px;\n  border-radius: 6px;\n  display: inline-block;\n  border-width: 1px;\n  border-style: solid;\n  text-align: center;\n  text-transform: none;\n  cursor: pointer;\n  font-weight: normal;\n  background-image: none;\n}\n\n.ub_review_cta_btn:hover,\n.ub_review_cta_btn:active {\n  background-image: none;\n}\n\n.ub_review_item_name {\n  font-size: 28px !important;\n  margin: 0 !important;\n  font-weight: 600 !important;\n}\n\n.ub_review_summary_title {\n  margin: 23px 0 13px 0 !important;\n  font-size: 24px !important;\n  font-weight: 600 !important;\n}\n\n.ub_review_stars {\n  display: flex;\n  margin-left: auto;\n  padding-top: 3px;\n}\n\n.ub_review_description {\n  padding: 0;\n}\n\n.ub_review_description_container {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  overflow: auto;\n}\n\n.ub_review_left_image {\n  flex-direction: row;\n}\n\n.ub_review_right_image {\n  flex-direction: row-reverse;\n}\n\n.ub_review_top_image {\n  flex-direction: column;\n}\n\n.ub_review_bottom_image {\n  flex-direction: column-reverse;\n}\n\n.ub_review_percentage {\n  display: grid;\n  grid-template-columns: 4fr 1fr;\n  overflow: auto;\n  margin-left: auto;\n}\n\n.ub_review_percentage > svg {\n  height: 10px;\n}\n\n.ub_review_percentage > div {\n  text-align: end;\n}\n\n.ub_review_percentage_bar {\n  width: 100%;\n  align-self: center;\n}\n\n.ub_review_percentage_bar_trail {\n  fill-opacity: 0;\n  stroke-linecap: round;\n}\n\n.ub_review_percentage_bar_path {\n  stroke-dasharray: 100px, 100px;\n  transition: stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear 0s;\n  fill-opacity: 0;\n  stroke-linecap: round;\n}\n\n.ub_review_cta_main {\n  display: flex;\n}\n\n@media (max-width: 7688px) {\n  .ub_review_block {\n    padding: 35px 40px;\n  }\n}\n\n@media (max-width: 576px) {\n  .ub_review_cta_btn {\n    padding: 15px 10px;\n  }\n  .ub_review_image {\n    float: right;\n  }\n}\n\n@media (max-width: 480px) {\n  .ub_review_rating {\n    font-size: 20px;\n    font-weight: 600;\n  }\n  .ub_review_entry {\n    font-size: 18px;\n  }\n  .ub_review_cta_btn {\n    padding: 15px 8px;\n  }\n}\n\n@media (max-width: 460px) {\n  .ub_review_average_stars svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n@media (max-width: 375px) {\n  .ub_review_block {\n    padding: 20px 15px;\n  }\n  .ub_review_block button > svg {\n    width: 12px;\n    height: 12px;\n  }\n}\n\n@media (max-width: 320px) {\n  .ub_review_block {\n    padding: 20px 10px;\n  }\n  .ub_review_block button > svg {\n    width: 8px;\n    height: 8px;\n    margin: 0;\n  }\n  .ub_review_average_stars {\n    height: 45px;\n    line-height: 40px;\n    margin-left: auto;\n  }\n}\n\n.wp-block-ub-social-share .social-share-icons {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.wp-block-ub-social-share .social-share-icons .social-share-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 7px;\n}\n\n.wp-block-ub-social-share .social-share-icons .social-share-icon.circle {\n  box-shadow: 0px 3px 2px gray;\n  border-radius: 50%;\n}\n\n.wp-block-ub-social-share .social-share-icons .social-share-icon.square {\n  box-shadow: 0px 3px 2px gray;\n  border-radius: 0%;\n}\n\n.wp-block-ub-social-share .social-share-icons .ub-social-share-standalone-icon {\n  margin: 12px;\n  padding-right: 5px;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-facebook-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-twitter-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-linkedin-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-pinterest-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-reddit-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share\n  .social-share-icons\n  .ub-social-share-tumblr-container {\n  border-width: 1px;\n  border-style: solid;\n  white-space: nowrap;\n  display: flex;\n}\n\n.wp-block-ub-social-share .social-share-icons > div {\n  display: flex;\n  align-items: center;\n}\n\n.wp-block-ub-social-share .social-share-icons a {\n  text-decoration: none;\n}\n\n.align-icons-center {\n  justify-content: center;\n}\n\n.align-icons-left {\n  justify-content: flex-start;\n}\n\n.align-icons-right {\n  justify-content: flex-end;\n}\n\n.ub-social-share-facebook.square,\n.ub-social-share-facebook.circle {\n  background-color: #1877f2;\n}\n\n.ub-social-share-facebook + span,\n.ub-social-share-facebook + span > a {\n  color: #1877f2;\n}\n\n.ub-social-share-twitter.square,\n.ub-social-share-twitter.circle {\n  background-color: #1d9bf0;\n}\n\n.ub-social-share-twitter + span,\n.ub-social-share-twitter + span > a {\n  color: #1d9bf0;\n}\n\n.ub-social-share-linkedin.square,\n.ub-social-share-linkedin.circle {\n  background-color: #2867b2;\n}\n\n.ub-social-share-linkedin + span,\n.ub-social-share-linkedin + span > a {\n  color: #2867b2;\n}\n\n.ub-social-share-pinterest.square,\n.ub-social-share-pinterest.circle {\n  background-color: #e60023;\n}\n\n.ub-social-share-pinterest + span,\n.ub-social-share-pinterest + span > a {\n  color: #e60023;\n}\n\n.ub-social-share-reddit.square,\n.ub-social-share-reddit.circle {\n  background-color: #ff4500;\n}\n\n.ub-social-share-reddit + span,\n.ub-social-share-reddit + span > a {\n  color: #ff4500;\n}\n\n.ub-social-share-tumblr.square,\n.ub-social-share-tumblr.circle {\n  background-color: #001935;\n}\n\n.ub-social-share-tumblr + span,\n.ub-social-share-tumblr + span > a {\n  color: #001935;\n}\n\n.ub-star-outer-container {\n  display: flex;\n}\n\n.ub-star-inner-container,\n.ub-star-container {\n  display: flex;\n  flex-direction: row;\n  margin: 20px 0;\n}\n\n.ub-star-inner-container svg {\n  margin-top: initial;\n}\n\n.ub-notification-box {\n  margin: 10px 0px;\n  padding: 15px;\n  border-left-width: 4px;\n  border-left-style: solid;\n}\n\n.ub-notification-box > *:first-child {\n  margin-top: 0;\n}\n\n.ub-notification-box > *:last-child {\n  margin-bottom: 0;\n}\n\n.ub-feature-box,\n.ub-number-box {\n  display: flex;\n  margin-top: 60px;\n  margin-bottom: 30px;\n}\n\n.ub-feature-box > div,\n.ub-number-box > div {\n  flex-basis: 100%;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  padding: 1rem;\n}\n\n.ub-feature-box > div:first-child:nth-last-child(3),\n.ub-number-box > div:first-child:nth-last-child(3) {\n  margin-left: 0;\n}\n\n.ub-feature-box > div:last-child:nth-child(3),\n.ub-number-box > div:last-child:nth-child(3) {\n  margin-right: 0;\n}\n\n.ub-number-panel {\n  border: 1px solid;\n}\n\n.ub-number-box .ub-number-panel .ub-number-container {\n  border-radius: 100px;\n  overflow: hidden;\n  border: medium none;\n  max-width: 80px;\n  margin: -60px auto 25px;\n}\n\n.ub-number-box .ub-number-panel .ub-number-container .ub-number-display {\n  font-size: 40px;\n  text-align: center;\n  line-height: 80px;\n  margin: 0 auto;\n}\n\n.ub-number-box .ub-number-panel .ub-number-box-title {\n  font-size: 30px;\n  text-align: center;\n  margin: 10px auto;\n  padding: 0;\n}\n\n.ub-feature-box .ub-feature img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.ub-feature-box .ub-feature .ub-feature-title {\n  font-size: 30px;\n  text-align: center;\n  margin: 20px 0;\n  padding: 0;\n}\n\n.ub-bordered-box {\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n.ub-bordered-box > p:last-child {\n  margin: 0;\n}\n\n@media screen and (max-width: 800px) {\n  .ub-feature-box,\n  .ub-number-box {\n    display: block;\n  }\n  .ub-feature-box > div,\n  .ub-number-box > div {\n    width: 90%;\n    margin: 0;\n  }\n}\n\n.ub_styled_list .fa-ul {\n  list-style-type: none;\n  margin-left: 1em;\n  padding-left: 0;\n  display: grid;\n  column-gap: 2em;\n}\n\n.ub_styled_list .fa-ul > li {\n  position: relative;\n  list-style: none;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n.ub_styled_list .fa-li {\n  display: inline-block;\n  left: -0.5em;\n  position: relative;\n}\n\n.ub_styled_list li::before {\n  content: \"\";\n  position: relative;\n  left: -0.5em;\n  display: inline-block;\n  background-repeat: no-repeat;\n}\n\nul.ub_styled_list {\n  list-style-type: none;\n  margin-left: 1em;\n  padding-left: 0;\n}\n\nul.ub_styled_list li {\n  position: relative;\n  list-style: none;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n\n.ub-hide {\n  display: none;\n}\n\n.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ub-toggle-transition {\n  transition: all 0.5s ease-in-out;\n}\n\n.ub-icon-holder {\n  position: relative;\n  transform: translate(-25%, 25%);\n}\n\n.ub-custom-id-input {\n  font-size: 0.9em;\n}\n\n@media (max-width: 699px) {\n  .ub-mobile-hide {\n    display: none;\n  }\n  .ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tablet-hide {\n    display: none;\n  }\n  .ub-tablet-display {\n    display: block;\n  }\n}\n\n.wp-block-ub-tabbed-content {\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n\n.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tabs-content {\n  border: 1px solid #d3d3d3;\n}\n\n.wp-block-ub-tabbed-content .wp-block-ub-tabbed-content-tab-title-wrap {\n  border: 1px solid #d3d3d3;\n  border-bottom: 0;\n}\n\n.wp-block-ub-tabbed-content-holder .blocks-rich-text__tinymce.mce-content-body {\n  font-size: 14px;\n}\n\n.wp-block-ub-tabbed-content-holder.vertical-holder {\n  display: flex;\n}\n\n.wp-block-ub-tabbed-content-tab-holder {\n  position: relative;\n}\n\n.wp-block-ub-tabbed-content-tab-holder.vertical-tab-width {\n  position: relative;\n  width: 21%;\n}\n\n.wp-block-ub-tabbed-content-tabs-title {\n  display: flex;\n  overflow-x: hidden;\n}\n\n.wp-block-ub-tabbed-content-tabs-title:hover,\n.wp-block-ub-tabbed-content-tabs-title:focus {\n  overflow-x: auto;\n}\n\n@media (max-width: 699px) {\n  .wp-block-ub-tabbed-content-tabs-title.ub-mobile-hide {\n    display: none;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .wp-block-ub-tabbed-content-tabs-title.ub-tablet-hide {\n    display: none;\n  }\n}\n\n.wp-block-ub-tabbed-content-tabs-content {\n  padding: 25px;\n}\n\n.wp-block-ub-tabbed-content-tabs-content.vertical-content-width {\n  width: 79%;\n}\n\n.wp-block-ub-tabbed-content-tab-title {\n  word-break: initial;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap {\n  border-top-right-radius: 5px;\n  border-top-left-radius: 5px;\n  padding: 10px 15px;\n  margin-right: 5px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap.active {\n  color: #fff;\n}\n\n.wp-block-ub-tabbed-content-tab-title-vertical-wrap {\n  border: 1px solid #d3d3d3;\n  border-top-left-radius: 5px;\n  padding: 10px 15px;\n  border-right: 0;\n  display: flex;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n}\n\n.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active {\n  color: #000;\n}\n\n@media (max-width: 699px) {\n  .ub-tabbed-content-mobile-accordion {\n    padding: 0;\n    border: none;\n  }\n  .ub-tabbed-content-mobile-accordion\n    > .wp-block-ub-tabbed-content-tab-content-wrap {\n    border: 1px solid #d3d3d3;\n    padding: 20px;\n  }\n  .ub-tabbed-content-mobile-accordion\n    > .wp-block-ub-tabbed-content-tab-content-wrap.active {\n    border-color: #a9a9a9;\n  }\n  .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap {\n    border: 1px solid #d3d3d3;\n    border-top-left-radius: 5px;\n    padding: 10px 15px;\n    border-right: 0;\n    display: flex;\n    align-items: center;\n    position: relative;\n    cursor: pointer;\n  }\n  .wp-block-ub-tabbed-content-tab-title-mobile-vertical-wrap.active {\n    color: #000;\n  }\n  .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-mobile {\n    width: 79%;\n  }\n  .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-mobile {\n    width: 100;\n  }\n  .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-mobile {\n    width: 21%;\n  }\n  .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-mobile {\n    width: 100%;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab {\n    display: initial;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-mobile-vertical-tab\n    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {\n    border-bottom: 1px solid #d3d3d3;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab {\n    display: flex;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-mobile-horizontal-tab\n    .wp-block-ub-tabbed-content-tab-title-vertical-wrap {\n    border-right: 1px solid #d3d3d3;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile {\n    display: block;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-mobile\n    > .wp-block-ub-tabbed-content-tabs-content {\n    width: 100%;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-mobile {\n    display: flex;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tabbed-content-tablet-accordion {\n    padding: 0;\n    border: none;\n  }\n  .ub-tabbed-content-tablet-accordion\n    > .wp-block-ub-tabbed-content-tab-content-wrap {\n    border: 1px solid #d3d3d3;\n    padding: 20px;\n  }\n  .ub-tabbed-content-tablet-accordion\n    > .wp-block-ub-tabbed-content-tab-content-wrap.active {\n    border-color: #a9a9a9;\n  }\n  .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {\n    border: 1px solid #d3d3d3;\n    border-top-left-radius: 5px;\n    padding: 10px 15px;\n    border-right: 0;\n    display: flex;\n    align-items: center;\n    position: relative;\n    cursor: pointer;\n  }\n  .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap.active {\n    color: #000;\n  }\n  .wp-block-ub-tabbed-content-tabs-content.vertical-content-width-tablet {\n    width: 79%;\n  }\n  .wp-block-ub-tabbed-content-tabs-content.horizontal-content-width-tablet {\n    width: 100%;\n  }\n  .wp-block-ub-tabbed-content-tab-holder.vertical-tab-width-tablet {\n    width: 21%;\n  }\n  .wp-block-ub-tabbed-content-tab-holder.horizontal-tab-width-tablet {\n    width: 100%;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab {\n    display: initial;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-tablet-vertical-tab\n    .wp-block-ub-tabbed-content-tab-title-tablet-vertical-wrap {\n    border-bottom: 1px solid #d3d3d3;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab {\n    display: flex;\n  }\n  .wp-block-ub-tabbed-content-tabs-title-tablet-horizontal-tab\n    .wp-block-ub-tabbed-content-tab-title-vertical-wrap {\n    border-right: 1px solid #d3d3d3;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet {\n    display: block;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-horizontal-holder-tablet\n    > .wp-block-ub-tabbed-content-tabs-content {\n    width: 100%;\n  }\n  .wp-block-ub-tabbed-content-holder.wp-block-ub-tabbed-content-vertical-holder-tablet {\n    display: flex;\n  }\n}\n\n.wp-block-ub-tabbed-content-accordion-toggle {\n  border: 1px solid #d3d3d3;\n  padding: 10px 15px;\n  display: none;\n}\n\n.wp-block-ub-tabbed-content-accordion-toggle.active {\n  border-bottom: none;\n}\n\n@media (max-width: 699px) {\n  .wp-block-ub-tabbed-content-accordion-toggle.ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .wp-block-ub-tabbed-content-accordion-toggle.ub-tablet-display {\n    display: block;\n  }\n}\n\n@media (max-width: 374.98px) {\n  .wp-block-ub-tabbed-content-tab-title-wrap {\n    padding: 10px 5px;\n  }\n  .wp-block-ub-tabbed-content-tabs-content {\n    padding: 10px;\n  }\n  .wp-block-ub-tabbed-content-tabs-content p {\n    margin: 0 0 10px 0;\n  }\n  .wp-block-ub-tabbed-content-scroll-button-container > button {\n    top: -30px;\n  }\n}\n\n.ub-hide {\n  display: none;\n}\n\n.ub-hiding {\n  height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.ub-toggle-transition {\n  transition: all 0.5s ease-in-out;\n}\n\n.ub-icon-holder {\n  position: relative;\n  transform: translate(-25%, 25%);\n}\n\n.ub-custom-id-input {\n  font-size: 0.9em;\n}\n\n@media (max-width: 699px) {\n  .ub-mobile-hide {\n    display: none;\n  }\n  .ub-mobile-display {\n    display: block;\n  }\n}\n\n@media (min-width: 700px) and (max-width: 899px) {\n  .ub-tablet-hide {\n    display: none;\n  }\n  .ub-tablet-display {\n    display: block;\n  }\n}\n\n.ub_table-of-contents {\n  box-sizing: border-box;\n  transition: all 0.5s ease-in-out;\n  background-color: #fafafa;\n  border: 1px solid #dfdfdf;\n  padding: 30px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  display: grid;\n}\n\n.ub_table-of-contents ul,\n.ub_table-of-contents ol {\n  margin-bottom: 0;\n  margin-left: 1.3em;\n  padding-inline-start: 0;\n  padding-left: 0;\n}\n\n.ub_table-of-contents ol {\n  list-style-type: none;\n  counter-reset: item;\n  margin: 0;\n  padding: 0;\n}\n\n.ub_table-of-contents ol > li {\n  display: table;\n  counter-increment: item;\n}\n\n.ub_table-of-contents ol > li:before {\n  content: counters(item, \".\") \". \";\n  display: table-cell;\n  padding-right: 0.6em;\n}\n\n.ub_table-of-contents li ol > li {\n  margin: 0;\n}\n\n.ub_table-of-contents li ol > li:before {\n  content: counters(item, \".\") \" \";\n}\n\n.ub_table-of-contents-header {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 500;\n  display: grid;\n  grid-template-columns: minmax(10px, 1fr) auto;\n  transition: all 0.5s ease-in-out;\n}\n\n.ub_table-of-contents-header-toggle {\n  display: flex;\n  align-items: center;\n  padding-left: 5px;\n}\n\n.ub_table-of-contents-collapsed {\n  padding: 10px;\n}\n\n.ub_table-of-contents-1-column {\n  column-count: 1;\n}\n\n.ub_table-of-contents-2-column {\n  column-count: 2;\n}\n\n.ub_table-of-contents-3-column {\n  column-count: 3;\n}\n\n.ub_table-of-contents-container {\n  transition: all 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n.ub_table-of-contents .ub_table-of-contents-container ul > li:before {\n  content: none;\n}\n\n.ub_table-of-contents-header-container,\n.ub_table-of-contents-extra-container {\n  padding: 15px 30px;\n  transition: all 0.5s ease-in-out;\n}\n\n.ub_table-of-contents-header-container {\n  display: grid;\n}\n\n.ub_table-of-contents,\n.ub_table-of-contents-collapsed {\n  padding: 0;\n}\n\n.ub_table-of-contents-collapsed .ub_table-of-contents-extra-container {\n  padding: 0;\n}\n\n@media screen and (max-width: 600px) {\n  .ub_table-of-contents-1-column,\n  .ub_table-of-contents-2-column,\n  .ub_table-of-contents-3-column {\n    column-count: 1;\n  }\n}\n\n.wp-block-ub-testimonial-block {\n  margin: 30px auto;\n  max-width: 100%;\n}\n\n.ub_testimonial {\n  max-width: 100%;\n  padding: 30px;\n  display: grid;\n  grid-template-columns: fit-content(25%) auto;\n  grid-template-rows: auto auto;\n  margin: 40px 0;\n}\n\n.ub_testimonial_img {\n  padding: 10px 10px;\n  grid-column-start: 1;\n  grid-row-start: 1;\n  grid-row-end: span 2;\n}\n\n.ub_testimonial_img img {\n  margin: 0 auto;\n  padding: 0;\n  border-radius: 50%;\n}\n\n.ub_testimonial_content {\n  grid-row-start: 1;\n  grid-column-start: 2;\n  padding: 11px 20px;\n}\n\n.ub_testimonial_content p {\n  font-style: italic;\n}\n\n.ub_testimonial_sign {\n  padding-right: 10px;\n  padding-bottom: 10px;\n  grid-column-start: 2;\n  grid-row-start: 2;\n}\n\n.ub_testimonial_sign p {\n  margin-bottom: 2px !important;\n}\n\n.ub_testimonial_sign .ub_testimonial_author_role {\n  margin-top: 0;\n  font-size: 13px;\n  font-style: italic;\n}\n\n@media (max-width: 479.98px) {\n  .ub_testimonial {\n    padding: 30px 10px;\n    display: block;\n  }\n  .ub_testimonial_img {\n    padding: 0;\n  }\n  .ub_testimonial_content {\n    padding: 10px;\n  }\n  .ub_testimonial_content p {\n    text-align: center !important;\n  }\n  .ub_testimonial_sign {\n    padding-right: 0;\n  }\n  .ub_testimonial_sign .ub_testimonial_author_role {\n    text-align: center !important;\n    margin-top: 5px;\n  }\n  .ub_testimonial_img,\n  .ub_testimonial_author {\n    text-align: center !important;\n  }\n}\n\n@media (max-width: 320px) {\n  .ub_testimonial_content {\n    padding: 10px 0;\n  }\n}\n\n.ultimate-blocks-icon-component {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ultimate-blocks-icon-component .ultimate-blocks-icon-component-svg-base {\n  width: 100%;\n  height: 100%;\n}\n\n@keyframes linearGradientMove {\n  to {\n    background-position: 6px 0, -6px 100%, 0 -6px, 100% 6px;\n  }\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap,\n.wp-block-ub-tabbed-content-tab-title-vertical-wrap {\n  background-color: inherit;\n  border-color: lightgrey;\n  color: inherit;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap.active,\n.wp-block-ub-tabbed-content-tab-title-vertical-wrap.active,\n.wp-block-ub-tabbed-content-accordion-toggle.active {\n  background-color: #13294b;\n  color: #ffffff;\n}\n\n.wp-block-ub-tabbed-content-accordion-toggle.active {\n  background-color: #13294b;\n}\n\n.wp-block-ub-tabbed-content-tabs-title {\n  justify-content: flex-start;\n}\n\n.wp-block-ub-tabbed-content-accordion-toggle {\n  background-color: transparent;\n  color: inherit;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(1) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(2) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(3) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(4) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(5) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(6) {\n  text-align: left;\n}\n\n.wp-block-ub-tabbed-content-tab-title-wrap:nth-child(7) {\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
